import '../style.scss';
import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import 'react-phone-input-2/lib/style.css';
import { IEditReportState, IPrivateSectorSuccessFactorsFinancialFlow, IRestorationPledgeTrackingDetailsTab, IPrivateSectorSuccessFactorsPlanningMethodology, IPrivateSectorSuccessFactorsMonitoringSystem, IPrivateSectorSuccessFactorsTab, ISuccessFactorsPolicyStrategies, IReportCountriesIndicators, ICountriesPrivateSectorSuccessFactorsTab, ISuccessFactorsFinancialFlow } from '../models/IEditReportState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import Select, { MultiValue } from 'react-select';
import Accordion from 'react-bootstrap/Accordion';
import ConfigService from '../../../../shared/configService';
import { Modal } from 'react-bootstrap';
import { IFeature } from '@esri/arcgis-rest-types';
import QueryService from '../../../../shared/queryService';
import { IRefTierFeature, IRefPlanningStatusFeature, IRefPlanningObservScalesFeature, IRefPlanningApproachScaleFeature, IRefMonitoringApproachScaleFeature, IRefMonitoringTrackedElemFeature, IRefRestorationPrinciplesFeature, IRefConfidenceFeature, IRefFinancialSupportFeature } from '../models/IRefFeature';
import Utils from '../../../../shared/utils';
import 'react-dropdown-tree-select/dist/styles.css';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import { constants } from 'buffer';
const SectorSuccessFactors = (props: { state: IEditReportState, setState: Function, validateData: Function }) => {
  const { t } = useTranslation('sectorreports');
  const MAX_LENGTH = ConfigService.getConfig().textEditorCharLength;

  /**
   * Get getOtherFinanicalSupportInputEnabled
   * @param val
   */
  const getOtherFinanicalSupportInputEnabled = (val: string): boolean => {
    return val.split(',').some((i: string) => i === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
  }

  // State
  interface ILocalState {
    reportLayerIndex: number;
    reportPoliciesLayerIndex: number;
    reportFinancialFlowLayerIndex: number;
    reportTechnicalPlanningLayerIndex: number;
    reportMonitoringLayerIndex: number;
    otherStatusInputEnabled: boolean;
    otherSystemTrackEnabled: boolean;
    currentDeletePolicyIndex: number;
    currentDeletePlanningMethodologyIndex: number;
    currentDeleteMonitoringSystemIndex: number;
    tiers: IRefTierFeature[];
    planningStatusFeatures: IRefPlanningStatusFeature[],
    planningObservScalesFeatures: IRefPlanningObservScalesFeature[],
    planningApproachScaleFeatures: IRefPlanningApproachScaleFeature[],
    monitoringTrackedElemFeatures: IRefMonitoringTrackedElemFeature[],
    monitoringGeoScaleFeatures: IRefMonitoringApproachScaleFeature[],
    policiesAndStrategiesTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    privateSectorFinancialFlowsTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    privateSectorTechnicalPlanningTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    privateSectorMonitoringTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    refRestorationPrinciplesFeature: IRefRestorationPrinciplesFeature[];
    confidenceFeature: IRefConfidenceFeature[];
    refFinancialSupportFeature: IRefFinancialSupportFeature[];
    otherFinancialSupportInputEnabled: boolean;
    selectedCountryIndicator: string;
    selectedCountryId: string;
    deletePolicyId: number;
    deleteTechPlanId: number;
    deleteMonitorSystemId: number;    
  }

  const [localState, setTheLocalState] = useState<ILocalState>({
    reportLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportMain.index,
    reportPoliciesLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportPolicies.index,
    reportFinancialFlowLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportFinancialFlows.index,
    reportTechnicalPlanningLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportTechnicalPlanning.index,
    reportMonitoringLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportMonitoring.index,
    otherStatusInputEnabled: false,
    otherSystemTrackEnabled: false,
    currentDeletePolicyIndex: -1,
    currentDeletePlanningMethodologyIndex: -1,
    currentDeleteMonitoringSystemIndex: -1,
    tiers: [],
    planningStatusFeatures: [],
    planningObservScalesFeatures: [],
    planningApproachScaleFeatures: [],
    monitoringTrackedElemFeatures: [],
    monitoringGeoScaleFeatures: [],
    policiesAndStrategiesTab: {
      isActive: false,
      isDisabled: false
    },
    privateSectorTechnicalPlanningTab: {
      isActive: false,
      isDisabled: false
    },
    privateSectorFinancialFlowsTab: {
      isActive: false,
      isDisabled: false
    },
    privateSectorMonitoringTab: {
      isActive: false,
      isDisabled: false
    },
    refRestorationPrinciplesFeature: [],
    confidenceFeature: [],
    refFinancialSupportFeature: [],
    otherFinancialSupportInputEnabled: getOtherFinanicalSupportInputEnabled(props.state.privateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.financial_support_used || ''),
    selectedCountryIndicator: '',
    selectedCountryId: '',
    deletePolicyId: 0,
    deleteTechPlanId: 0,
    deleteMonitorSystemId: 0    
  });

  const [isMaxCount, setisMaxCount] = useState(false);
  
  // Confirm dialog
  const [showRevertToGlobalDialog, setRevertToGlobalDialogShow] = useState(false);
  const [showPolicyDialog, setPolicyDialogShow] = useState(false);
  const [showPlanningMethodologyDialog, setPlanningMethodologyDialogShow] = useState(false);
  const [showMonitoringSystemDialog, setMonitoringSystemDialogShow] = useState(false);

  const [editorStateRevpolicy, seteditorStateRevpolicy] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateOthInfo, seteditorStateOthInfo] = useState(
    () => EditorState.createEmpty(),
  );
  
  const [editorStatePolyCit, seteditorStatePolyCit] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateMethodology, seteditorStateMethodology] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateExplanation, seteditorStateExplanation] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateRevLink, seteditorStateRevLink] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateFinContr, seteditorStateFinContr] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateSrc, seteditorStateSrc] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateMonSys, seteditorStateMonSys] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateMonContr, seteditorStateMonContr] = useState(
    () => EditorState.createEmpty(),
  );

  const [editorStateMonCit, seteditorStateMonCit] = useState(
    () => EditorState.createEmpty(),
  );



  let propscontentLink: any = '';
  // Use effect
  useEffect(() => {
    setFinancialFlowsIntro();
    getRefFeatures();
    loadContentData(props.state.privateSectorSuccessFactorsTab!, false);
  }, [propscontentLink]);

  useEffect(() => {
    const obj: IEditReportState = { ...props.state } as IEditReportState;

    const subObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

    if (subObj && !props.state.privateSectorSuccessFactorsTab?.isGlobalMode) {
      addResultsAndBenefitsItem(true);
    }

    enableDisableTabs(props.state.restorationPledgeTrackingDetailsTab?.location_specific, '');
  }, [props.state.restorationPledgeTrackingDetailsTab?.action_indicators]
  );

  const loadContentData = (val: any, isNewRecord: boolean) => {

    if (getSelectedPolicy()?.information) {
      propscontentLink = isNewRecord && val.information != undefined ? val.information?.toString() : getSelectedPolicy()?.information?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateRevpolicy(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateRevpolicy(EditorState.createWithContent(contentState));
    }


    if (getSelectedPolicy()?.responsible) {
      propscontentLink = isNewRecord && val.responsible != undefined ? val.responsible?.toString() : getSelectedPolicy()?.responsible?.toString();
      
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap       
      );

      seteditorStateOthInfo(EditorState.createWithContent(contentState));

      // if(propscontentLink.length > 40)
      // {        
      //   toast.error(t('newReport.reportAlreadyExists')); 
      //   propscontentLink = '';
      //   const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      //   const contentState = ContentState.createFromBlockArray(
      //     contentBlocks.contentBlocks,
      //     contentBlocks.entityMap
      //   );

      //   seteditorStateOthInfo(EditorState.createWithContent(contentState));     
      // }
      // else
      // {
      //   const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));
      //   const contentState = ContentState.createFromBlockArray(
      //     contentBlocks.contentBlocks,
      //     contentBlocks.entityMap       
      //   );
      //   seteditorStateOthInfo(EditorState.createWithContent(contentState));
      // }      
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateOthInfo(EditorState.createWithContent(contentState));
    }


    if (getSelectedPolicy()?.links) {
      propscontentLink = isNewRecord && val.links != undefined ? val.links?.toString() : getSelectedPolicy()?.links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStatePolyCit(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStatePolyCit(EditorState.createWithContent(contentState));
    }


    if (getSelectedPlanningMethodology()?.methodology) {
      propscontentLink = isNewRecord && val.methodology != undefined ? val.methodology?.toString() : getSelectedPlanningMethodology()?.methodology?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateMethodology(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateMethodology(EditorState.createWithContent(contentState));
    }


    if (getSelectedPlanningMethodology()?.explanation) {
      propscontentLink = isNewRecord && val.explanation != undefined ? val.explanation?.toString() : getSelectedPlanningMethodology()?.explanation?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateExplanation(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateExplanation(EditorState.createWithContent(contentState));
    }


    if (getSelectedPlanningMethodology()?.links) {
      propscontentLink = getSelectedPlanningMethodology()?.links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateRevLink(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateRevLink(EditorState.createWithContent(contentState));
    }

    if (val.privateSectorFinancialFlowsTab != undefined && (val.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.country_id != undefined || val.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.country_id != null || val.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.country_id != '') && val.isGlobalMode == true) {
      if (val.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.financial_support_contribute != undefined) {
        propscontentLink = val.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.financial_support_contribute?.toString();
        const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

        const contentState = ContentState.createFromBlockArray(
          contentBlocks.contentBlocks,
          contentBlocks.entityMap
        );

        seteditorStateFinContr(EditorState.createWithContent(contentState));
      }


      if (val.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.sources != undefined) {
        propscontentLink = val.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.sources?.toString();
        const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

        const contentState = ContentState.createFromBlockArray(
          contentBlocks.contentBlocks,
          contentBlocks.entityMap
        );

        seteditorStateSrc(EditorState.createWithContent(contentState));
      }
    }
    else {
      if (getSelectedFunding()?.financial_support_contribute) {
        propscontentLink = getSelectedFunding()?.financial_support_contribute;
        const contentBlocksFinContribute = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

        const contentStateFinContribute = ContentState.createFromBlockArray(
          contentBlocksFinContribute.contentBlocks,
          contentBlocksFinContribute.entityMap
        );
        seteditorStateFinContr(EditorState.createWithContent(contentStateFinContribute));
      }
      if (getSelectedFunding()?.financial_support_contribute) {
        propscontentLink = getSelectedFunding()?.sources;
        const contentBlocksFinContribute = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

        const contentStateFinContribute = ContentState.createFromBlockArray(
          contentBlocksFinContribute.contentBlocks,
          contentBlocksFinContribute.entityMap
        );
        seteditorStateSrc(EditorState.createWithContent(contentStateFinContribute));
      }
    }

    if (getSelectedMonitoringSystem()?.monitoring_system) {
      propscontentLink = isNewRecord && val.monitoring_system != undefined ? val.monitoring_system?.toString() : getSelectedMonitoringSystem()?.monitoring_system?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateMonSys(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateMonSys(EditorState.createWithContent(contentState));
    }

    if (getSelectedMonitoringSystem()?.information) {
      propscontentLink = isNewRecord && val.information != undefined ? val.information?.toString() : getSelectedMonitoringSystem()?.information?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateMonContr(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateMonContr(EditorState.createWithContent(contentState));
    }


    if (getSelectedMonitoringSystem()?.links) {
      propscontentLink = isNewRecord && val.links != undefined ? val.links?.toString() : getSelectedMonitoringSystem()?.links?.toString();
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateMonCit(EditorState.createWithContent(contentState));
    }
    else {
      propscontentLink = '';
      const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(propscontentLink));

      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );

      seteditorStateMonCit(EditorState.createWithContent(contentState));
    }
  }

  const loadAddNewContentData = () => {

    const contentBlocks = convertFromHTML(Utils.trimWhiteSpace(''));
    const contentState = ContentState.createFromBlockArray(
      contentBlocks.contentBlocks,
      contentBlocks.entityMap
    );
    //1.Policy
    seteditorStateRevpolicy(EditorState.createWithContent(contentState));
    seteditorStateOthInfo(EditorState.createWithContent(contentState));
    seteditorStatePolyCit(EditorState.createWithContent(contentState));

    //2. Tech
    seteditorStateMethodology(EditorState.createWithContent(contentState));
    seteditorStateExplanation(EditorState.createWithContent(contentState));
    seteditorStateRevLink(EditorState.createWithContent(contentState));

    //3. Funding
    seteditorStateFinContr(EditorState.createWithContent(contentState));
    seteditorStateSrc(EditorState.createWithContent(contentState));

    //4. Monitoring Systems
    seteditorStateMonSys(EditorState.createWithContent(contentState));
    seteditorStateMonContr(EditorState.createWithContent(contentState));
    seteditorStateMonCit(EditorState.createWithContent(contentState));
  }


  //Set financial flow Intro
  const setFinancialFlowsIntro = () => {
    const financialIntro: HTMLSpanElement | null = document.getElementById('financialIntroSector');

    if (financialIntro) {
      financialIntro.innerHTML = t('newReport.successFactors.finHeaderNotes');
    }
  }

  /**
   * Get reference list
   */
  const getRefFeatures = async () => {

    // Ref data
    const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
    const tierFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_TIERS.index);
    const planningStatusFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_PLANNING_STATUS.index);
    const planningObservScalesFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_PLANNING_OBSERVATION_SCALE.index);
    const planningApproachScaleFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_PLANNING_APPROACH_SCALE.index);
    //const monitoringTrackedElemFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_MONITORING_TRACKED_ELEMENTS.index);
    const monitoringTrackedElemFeatures: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_MONITORING_TRACKED_ELEMENTS.index), sectorFilter, false, '*', `${ConfigService.getConfig().agol.referenceTables.REF_MONITORING_TRACKED_ELEMENTS.fields.key} ASC`);
    const monitoringGeoScaleFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_MONITORING_APPROACH_SCALE.index);
    const restorationPrinciplesFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_PLANNING_ECOSYSTEM.index), '', false, '*', '');
    const confidenceDataFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_TIERS.index), sectorFilter, false, '*', '');
    const financialSupportFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_FINANCIAL_SUPPORT.index), '', false, '*', '');

    const obj: ILocalState = { ...localState };
    obj.tiers = tierFeatures.map((feat: IFeature) => feat.attributes as IRefTierFeature);
    obj.planningStatusFeatures = planningStatusFeatures.map((feat: IFeature) => feat.attributes as IRefPlanningStatusFeature);
    obj.planningObservScalesFeatures = planningObservScalesFeatures.map((feat: IFeature) => feat.attributes as IRefPlanningObservScalesFeature);
    obj.planningApproachScaleFeatures = planningApproachScaleFeatures.map((feat: IFeature) => feat.attributes as IRefPlanningApproachScaleFeature);
    obj.monitoringTrackedElemFeatures = monitoringTrackedElemFeatures.map((feat: IFeature) => feat.attributes as IRefMonitoringTrackedElemFeature);
    obj.monitoringGeoScaleFeatures = monitoringGeoScaleFeatures.map((feat: IFeature) => feat.attributes as IRefMonitoringApproachScaleFeature);
    obj.refRestorationPrinciplesFeature = restorationPrinciplesFeature.map((feat: IFeature) => feat.attributes as IRefRestorationPrinciplesFeature);
    obj.confidenceFeature = confidenceDataFeature.map((feat: IFeature) => feat.attributes as IRefConfidenceFeature);
    obj.refFinancialSupportFeature = financialSupportFeature.map((feat: IFeature) => feat.attributes as IRefFinancialSupportFeature);
    setTheLocalState(obj);

    // Get layer infos
    await QueryService.getLayerFieldsInfos(localState.reportPoliciesLayerIndex);
    await QueryService.getLayerFieldsInfos(localState.reportFinancialFlowLayerIndex);
    await QueryService.getLayerFieldsInfos(localState.reportTechnicalPlanningLayerIndex);
    await QueryService.getLayerFieldsInfos(localState.reportMonitoringLayerIndex);

    // Validate data
    callSetState({ ...props.state });
  };


  const handleRestorationPrinciplesChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    updateSelectedPlanningMethodology('ecosystem_resto_principles', val);
  }

  const handleFinancialSupportChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setFinancialFlowsState(0, 'financial_support_used', val);

    const obj: ILocalState = { ...localState };
    obj.otherFinancialSupportInputEnabled = getOtherFinanicalSupportInputEnabled(val);
    setTheLocalState(obj);
  }

  /**
   * Call set state (with validation)
   * @param obj
   */
  const callSetState = (obj: IEditReportState) => {

    const sfTab: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
    const countryTab: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

    if (sfTab) {
      props.validateData(sfTab);
    }

    if (countryTab) {
      props.validateData(countryTab);
    }


    obj.privateSectorSuccessFactorsTab = sfTab;
    obj.countriesPrivateSectorSuccessFactorsTab = countryTab;
    props.setState(obj);
  }

  /**
   * Set financial flows state
   * @param tabIndex
   * @param prop
   * @param value
   */
  const setFinancialFlowsState = (tabIndex: number, prop: string, value: any) => {

    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (props.state.privateSectorSuccessFactorsTab?.isGlobalMode) {
        (subObj.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure as any)[prop] = value;
        subObj.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure!.report_id = obj.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID];
        subObj.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure!.country_id = '';
        subObj.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure!.country_name = '';
      }
      else {
        subCountryObj.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure!.map((i: IPrivateSectorSuccessFactorsFinancialFlow) => {
          if (i.country_id == localState.selectedCountryId) {
            (i as any)[prop] = value;
            i.report_id = obj.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID];
          }

        })
      }

      callSetState(obj);
    }
  }

  /**
   * Select tab
   * @param index
   */
  const selectTab = (index: number) => {
    const obj: ILocalState = { ...localState };

    obj.policiesAndStrategiesTab.isActive = index === 0;
    obj.privateSectorTechnicalPlanningTab.isActive = index === 1;
    obj.privateSectorFinancialFlowsTab.isActive = index === 2;
    obj.privateSectorMonitoringTab.isActive = index === 3;

    setTheLocalState(obj);
  }


  /**
   * Enable disable tab
   * @param index
   */
  const enableDisableTabs = (locationSpec: any, selectectItem: any) => {
    const obj: ILocalState = { ...localState };
    let flag: boolean = false;
    let countryflag: boolean = false;

    if (locationSpec != '1') {
      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('1') === -1) {
        obj.policiesAndStrategiesTab.isDisabled = true;
        obj.policiesAndStrategiesTab.isActive = false;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('2') === -1) {
        obj.privateSectorTechnicalPlanningTab.isDisabled = true;
        obj.privateSectorTechnicalPlanningTab.isActive = false;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('3') === -1) {
        obj.privateSectorFinancialFlowsTab.isDisabled = true;
        obj.privateSectorFinancialFlowsTab.isActive = false;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('4') === -1) {
        obj.privateSectorMonitoringTab.isDisabled = true;
        obj.privateSectorMonitoringTab.isActive = false;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('1') !== -1) {
        obj.policiesAndStrategiesTab.isDisabled = false;
        //obj.policiesAndStrategiesTab.isActive = true;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('2') !== -1) {
        obj.privateSectorTechnicalPlanningTab.isDisabled = false;
        //obj.privateSectorTechnicalPlanningTab.isActive = true;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('3') !== -1) {
        obj.privateSectorFinancialFlowsTab.isDisabled = false;
        //obj.privateSectorFinancialFlowsTab.isActive = true;
      }
      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('4') !== -1) {
        obj.privateSectorMonitoringTab.isDisabled = false;
        //obj.privateSectorMonitoringTab.isActive = true;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('1') !== -1 && !flag) {
        flag = true;
        obj.policiesAndStrategiesTab.isActive = true;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('2') !== -1 && !flag) {
        flag = true;
        obj.privateSectorTechnicalPlanningTab.isActive = true;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('3') !== -1 && !flag) {
        flag = true;
        obj.privateSectorFinancialFlowsTab.isActive = true;
      }

      if (props.state.restorationPledgeTrackingDetailsTab?.action_indicators?.indexOf('4') !== -1 && !flag) {
        flag = true;
        obj.privateSectorMonitoringTab.isActive = true;
      }
    }
    else {
      props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators.forEach((el: IReportCountriesIndicators, i: number) => {

        if (selectectItem.country_indicator == el.country_indicator) {
          if (el.action_indicator?.indexOf('1') == -1) {
            obj.policiesAndStrategiesTab.isDisabled = true;
            obj.policiesAndStrategiesTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('2') == -1) {
            obj.privateSectorTechnicalPlanningTab.isDisabled = true;
            obj.privateSectorTechnicalPlanningTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('3') == -1) {
            obj.privateSectorFinancialFlowsTab.isDisabled = true;
            obj.privateSectorFinancialFlowsTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('4') == -1) {
            obj.privateSectorMonitoringTab.isDisabled = true;
            obj.privateSectorMonitoringTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('1') != -1) {
            obj.policiesAndStrategiesTab.isDisabled = false;
          }

          if (el.action_indicator?.indexOf('2') != -1) {
            obj.privateSectorTechnicalPlanningTab.isDisabled = false;
          }

          if (el.action_indicator?.indexOf('3') != -1) {
            obj.privateSectorFinancialFlowsTab.isDisabled = false;
          }

          if (el.action_indicator?.indexOf('4') != -1) {
            obj.privateSectorMonitoringTab.isDisabled = false;
          }

          if (el.action_indicator?.indexOf('1') !== -1 && !countryflag) {
            countryflag = true;
            obj.policiesAndStrategiesTab.isActive = true;
            obj.privateSectorTechnicalPlanningTab.isActive = false;
            obj.privateSectorFinancialFlowsTab.isActive = false;
            obj.privateSectorMonitoringTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('2') !== -1 && !countryflag) {
            countryflag = true;
            obj.privateSectorTechnicalPlanningTab.isActive = true;
            obj.privateSectorFinancialFlowsTab.isActive = false;
            obj.privateSectorMonitoringTab.isActive = false;
            obj.policiesAndStrategiesTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('3') !== -1 && !countryflag) {
            countryflag = true;
            obj.privateSectorFinancialFlowsTab.isActive = true;
            obj.privateSectorTechnicalPlanningTab.isActive = false;
            obj.privateSectorMonitoringTab.isActive = false;
            obj.policiesAndStrategiesTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('4') !== -1 && !countryflag) {
            countryflag = true;
            obj.privateSectorMonitoringTab.isActive = true;
            obj.privateSectorTechnicalPlanningTab.isActive = false;
            obj.privateSectorFinancialFlowsTab.isActive = false;
            obj.policiesAndStrategiesTab.isActive = false;
          }
        }
        else if (i == 0) {
          obj.policiesAndStrategiesTab.isDisabled = false;
          obj.privateSectorTechnicalPlanningTab.isDisabled = false;
          obj.privateSectorFinancialFlowsTab.isDisabled = false;
          obj.privateSectorMonitoringTab.isDisabled = false;
          if (el.action_indicator?.indexOf('1') == -1) {
            obj.policiesAndStrategiesTab.isDisabled = true;
          }

          if (el.action_indicator?.indexOf('2') == -1) {
            obj.privateSectorTechnicalPlanningTab.isDisabled = true;
          }

          if (el.action_indicator?.indexOf('3') == -1) {
            obj.privateSectorFinancialFlowsTab.isDisabled = true;
          }

          if (el.action_indicator?.indexOf('4') == -1) {
            obj.privateSectorMonitoringTab.isDisabled = true;
          }
          if (el.action_indicator?.indexOf('1') !== -1 && !flag) {
            flag = true;
            obj.policiesAndStrategiesTab.isActive = true;
            obj.privateSectorTechnicalPlanningTab.isActive = false;
            obj.privateSectorFinancialFlowsTab.isActive = false;
            obj.privateSectorMonitoringTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('2') !== -1 && !flag) {
            flag = true;
            obj.privateSectorTechnicalPlanningTab.isActive = true;
            obj.policiesAndStrategiesTab.isActive = false;
            obj.privateSectorFinancialFlowsTab.isActive = false;
            obj.privateSectorMonitoringTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('3') !== -1 && !flag) {
            flag = true;
            obj.privateSectorFinancialFlowsTab.isActive = true;
            obj.privateSectorTechnicalPlanningTab.isActive = false;
            obj.policiesAndStrategiesTab.isActive = false;
            obj.privateSectorMonitoringTab.isActive = false;
          }

          if (el.action_indicator?.indexOf('4') !== -1 && !flag) {
            flag = true;
            obj.privateSectorMonitoringTab.isActive = true;
            obj.privateSectorFinancialFlowsTab.isActive = false;
            obj.privateSectorTechnicalPlanningTab.isActive = false;
            obj.policiesAndStrategiesTab.isActive = false;
          }
        }
      });
    }


    setTheLocalState(obj);
  }


  /**
   * Add new policy
   */
  const addNewPolicy = () => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      if (subObj.isGlobalMode == true) {
        if (subObj.policiesAndStrategiesTab.policiesAndStrategies.length === 10) {
          return;
        }
      }
      else {
        if (subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.length === 10) {
          return;
        }
      }
      const policy: ISuccessFactorsPolicyStrategies = {
        isActive: true,
        name: t('newReport.successFactors.defaultPolicyName'),
        OBJECTID: -1,
        country_id: '',
        information: '',
        links: '',
        responsible: '',
        report_id: props.state.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID]
      }
      if (subObj.isGlobalMode == true) {
        // Add new policy
        subObj.policiesAndStrategiesTab.policiesAndStrategies.unshift(policy);

        subObj.policiesAndStrategiesTab.policiesAndStrategies.forEach((p: ISuccessFactorsPolicyStrategies, i: number) => {
          p.isActive = i === 0;
        });
        if (subObj.policiesAndStrategiesTab.policiesAndStrategies.length > 1) {
          loadAddNewContentData();
        }
      }
      else {
        // Add new policy
        policy.country_id = localState.selectedCountryId;
        subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.unshift(policy);

        subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.forEach((p: ISuccessFactorsPolicyStrategies, i: number) => {
          p.isActive = i === 0;
        });
        if (subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.length > 1) {
          loadAddNewContentData();
        }
      }


      callSetState(obj);
    }
  }

  /**
   * Delete policy
   * @param event
   * @param index
   */
  const deletePolicy = (event: any, index: number, objId: any) => {
    event.stopPropagation();
    setCurrentPolicyIndex(index, objId);
    handlePolicyDialogShow();
  }

  /**
   * Select policy
   * @param index
   */
  const selectPolicy = (index: number, objId: any) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      if (subObj.isGlobalMode == true) {
        subObj.policiesAndStrategiesTab.policiesAndStrategies.forEach((p: ISuccessFactorsPolicyStrategies, i: number) => {
          p.isActive = i === index;
        });
        callSetState(obj);
        loadContentData(obj.privateSectorSuccessFactorsTab?.policiesAndStrategiesTab, false);
      }
      else {
        let activeFlag = false;
        subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.forEach((p: ISuccessFactorsPolicyStrategies, i: number) => {
          p.isActive = false;
          if (p.country_id == localState.selectedCountryId && p.OBJECTID == objId) {
            if (!activeFlag && i == index) {
              p.isActive = true;
              activeFlag = true;
            }
          }

          if (objId != -1 && p.OBJECTID == objId && !activeFlag) {
            p.isActive = true;
            activeFlag = true;
          }

        });
        callSetState(obj);
        loadContentData(obj.countriesPrivateSectorSuccessFactorsTab?.policiesAndStrategiesTab, false);
      }
    }
  }

  /**
   * Update selected policy
   * @param prop
   * @param value
   */
  const updateSelectedPolicy = (prop: string, value: any) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      if (subObj.isGlobalMode == true) {
        const policy: ISuccessFactorsPolicyStrategies | undefined = subObj.policiesAndStrategiesTab.policiesAndStrategies.find((p: ISuccessFactorsPolicyStrategies, i: number) => p.isActive);

        if (policy) {
          (policy as any)[prop] = value;
          policy.report_id = obj.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID];
          callSetState(obj);
        }
      }
      else {
        const policy: ISuccessFactorsPolicyStrategies | undefined = subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.find((p: ISuccessFactorsPolicyStrategies, i: number) => p.isActive);

        if (policy) {
          (policy as any)[prop] = value;
          policy.report_id = obj.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID];
          if (localState.selectedCountryId != undefined && localState.selectedCountryId != null && localState.selectedCountryId != '') {
            policy.country_id = localState.selectedCountryId;
          }
          if (localState.selectedCountryIndicator != undefined && localState.selectedCountryIndicator != null && localState.selectedCountryIndicator != '') {
            policy.country_name = localState.selectedCountryIndicator;
          }
          callSetState(obj);
        }
      }
    }
  }


  /**
   * Get selected policy
   * @returns
   */
  const getSelectedPolicy = (): ISuccessFactorsPolicyStrategies | undefined => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subObjCPS: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      if (subObj.isGlobalMode) {
        // if (subObj.policiesAndStrategiesTab!.policiesAndStrategies.length > 0) {
        //   subObj.policiesAndStrategiesTab!.policiesAndStrategies[0].isActive = true;
        // }
        return subObj.policiesAndStrategiesTab.policiesAndStrategies.find((p: ISuccessFactorsPolicyStrategies, i: number) => p.isActive);
      }
      else {

        return subObjCPS.policiesAndStrategiesTab.policiesAndStrategies.find((p: ISuccessFactorsPolicyStrategies, i: number) => p.isActive);
      }
    }

    return undefined;
  }


  /**
  * Get selected policy
  * @returns
  */
  const getSelectedFunding = (): IPrivateSectorSuccessFactorsFinancialFlow | undefined => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObjCPS: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      if(localState.selectedCountryId != '')
      {
        return subObjCPS.privateSectorFinancialFlowsTab!.totalDomesticPublicExpenditure!.find((p: IPrivateSectorSuccessFactorsFinancialFlow, i: number) => p.country_id == localState.selectedCountryId);
      }      
    }

    return undefined;
  }


  /**
   * Set current policy index
   * @param i
   */
  const setCurrentPolicyIndex = (i: number, objId: any) => {
    const obj: ILocalState = { ...localState };
    obj.currentDeletePolicyIndex = i;
    obj.deletePolicyId = objId;
    if (i == -1) {
      selectPolicy(0, -1);
    }
    setTheLocalState(obj);
  }

  /**
   * Add new PlanningMethodology
   */
  const addNewPlanningMethodology = () => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (subObj.isGlobalMode == true) {
        if (subObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.length === 10) {
          return;
        }
      }
      else {
        if (subCountryObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.length === 10) {
          return;
        }
      }

      const planningMethodology: IPrivateSectorSuccessFactorsPlanningMethodology = {
        isActive: true,
        //methodology: t('newReport.successFactors.defaultPlanningMethodology'),
        methodology: '',
        OBJECTID: -1,
        report_id: props.state.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID]
      }

      if (subObj.isGlobalMode == true) {
        // Add new PlanningMethodology
        subObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.unshift(planningMethodology);
        subObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.forEach((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => {
          p.isActive = i === 0;
        });
        if (subObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.length > 1) {
          loadAddNewContentData();
        }
      }
      else {
        planningMethodology.country_id = localState.selectedCountryId;
        subCountryObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.unshift(planningMethodology);
        subCountryObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.forEach((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => {
          p.isActive = i === 0;
        });
        if (subCountryObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.length > 1) {
          loadAddNewContentData();
        }
      }

      callSetState(obj);
    }
  }

  /**
   * Delete PlanningMethodology
   * @param event
   * @param index
   */
  const deletePlanningMethodology = (event: any, index: number, objId: any) => {
    event.stopPropagation();
    setCurrentPlanningMethodologyIndex(index, objId);
    handlePlanningMethodologyDialogShow();
  }

  /**
   * Select PlanningMethodology
   * @param index
   */
  const selectPlanningMethodology = (index: number, objId: any) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (subObj.isGlobalMode == true) {
        subObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.forEach((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => {
          p.isActive = i === index;
        });
        callSetState(obj);
        loadContentData(obj.privateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies, false);
      }
      else {
        let activeFlag = false;
        subCountryObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.forEach((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => {
          p.isActive = false;
          if (p.country_id == localState.selectedCountryId && p.OBJECTID == objId) {
            if (!activeFlag && i == index) {
              p.isActive = true;
              activeFlag = true;
            }
          }

          if (objId != -1 && p.OBJECTID == objId && !activeFlag) {
            p.isActive = true;
            activeFlag = true;
          }

        });
        callSetState(obj);
        loadContentData(obj.countriesPrivateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab, false);
      }


    }
  }

  /**
   * Update selected PlanningMethodology
   * @param prop
   * @param value
   */
  const updateSelectedPlanningMethodology = (prop: string, value: any) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (subObj.isGlobalMode == true) {
        const planningMethodology: IPrivateSectorSuccessFactorsPlanningMethodology | undefined = subObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.find((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => p.isActive);

        if (planningMethodology) {
          (planningMethodology as any)[prop] = value;
          callSetState(obj);
        }
      }
      else {
        const planningMethodology: IPrivateSectorSuccessFactorsPlanningMethodology | undefined = subCountryObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.find((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => p.isActive);
        if (planningMethodology) {
          (planningMethodology as any)[prop] = value;
          planningMethodology.report_id = obj.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID];
          if (localState.selectedCountryId != undefined && localState.selectedCountryId != null && localState.selectedCountryId != '') {
            planningMethodology.country_id = localState.selectedCountryId;
          }
          if (localState.selectedCountryIndicator != undefined && localState.selectedCountryIndicator != null && localState.selectedCountryIndicator != '') {
            planningMethodology.country_name = localState.selectedCountryIndicator;
          }
          callSetState(obj);
        }
      }
    }
  }


  /**
   * Get selected PlanningMethodology
   * @returns
   */
  const getSelectedPlanningMethodology = (): IPrivateSectorSuccessFactorsPlanningMethodology | undefined => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subObjCPS: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      if (subObj.isGlobalMode) {
        return subObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.find((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => p.isActive);
      }
      else {
        // if (subObjCPS.privateSectorTechnicalPlanningTab!.privateSectorPlanningMethodologies.length > 0) {
        //   subObjCPS.privateSectorTechnicalPlanningTab!.privateSectorPlanningMethodologies[0].isActive = true;
        // }
        return subObjCPS.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.find((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => p.isActive && p.country_id==localState.selectedCountryId);
      }
    }

    return undefined;
  }

  /**
   * Set current PlanningMethodology index
   * @param i
   */
  const setCurrentPlanningMethodologyIndex = (i: number, objId: any) => {
    const obj: ILocalState = { ...localState };
    obj.currentDeletePlanningMethodologyIndex = i;
    obj.deleteTechPlanId = objId;
    if (i == -1) {
      selectPlanningMethodology(0, -1);
    }
    setTheLocalState(obj);
  }

  // /**
  //  * Handle planning status change
  //  * @param date
  //  */
  // const handlePlanningStatusChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
  //   updateSelectedPlanningMethodology('landscape_status', items && items.length ? items.map(i => i.value).join(',') : '');

  //   const obj: ILocalState = { ...localState };
  //   obj.otherStatusInputEnabled = items && items.some((i: any) => i.value === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
  //   setTheLocalState(obj);
  // }

  /**
   * Add new MonitoringSystem
   */
  const addNewMonitoringSystem = () => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (subObj.isGlobalMode == true) {
        if (subObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.length === 10) {
          return;
        }
      }
      else {
        if (subCountryObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.length === 10) {
          return;
        }
      }
      const monitoringSystem: IPrivateSectorSuccessFactorsMonitoringSystem = {
        isActive: true,
        monitoring_system: '',
        OBJECTID: -1,
        country_id: '',
        report_id: props.state.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID]
      }

      if (subObj.isGlobalMode == true) {
        // Add new MonitoringSystem
        subObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.unshift(monitoringSystem);

        subObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.forEach((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => {
          p.isActive = i === 0;
        });

        if (subObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.length > 1) {
          loadAddNewContentData();
        }
      }
      else {
        monitoringSystem.country_id = localState.selectedCountryId;
        subCountryObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.unshift(monitoringSystem);

        subCountryObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.forEach((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => {
          p.isActive = i === 0;
        });
        if (subCountryObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.length > 1) {
          loadAddNewContentData();
        }
      }

      callSetState(obj);
    }
  }

  /**
   * Delete MonitoringSystem
   * @param event
   * @param index
   */
  const deleteMonitoringSystem = (event: any, index: number, objId: any) => {
    event.stopPropagation();
    setCurrentMonitoringSystemIndex(index, objId);
    handleMonitoringSystemDialogShow();
  }

  /**
   * Select MonitoringSystem
   * @param index
   */
  const selectMonitoringSystem = (index: number, objId: any) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (subObj.isGlobalMode == true) {
        subObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.forEach((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => {
          p.isActive = i === index;
        });

        callSetState(obj);
        loadContentData(obj.privateSectorSuccessFactorsTab?.privateSectorMonitoringTab, false);
      }
      else {
        let activeFlag = false;
        subCountryObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.forEach((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => {
          p.isActive = false;
          if (p.country_id == localState.selectedCountryId && p.OBJECTID == objId) {
            if (!activeFlag && i == index) {
              p.isActive = true;
              activeFlag = true;
            }
          }
          // else if (p.country_id == localState.selectedCountryId && objId == -1 && index == 0) {
          //   p.isActive = true;
          // }
          if (objId != -1 && p.OBJECTID == objId && !activeFlag) {
            p.isActive = true;
            activeFlag = true;
          }

        });
        callSetState(obj);
        loadContentData(obj.countriesPrivateSectorSuccessFactorsTab?.privateSectorMonitoringTab, false);
      }

    }
  }

  /**
   * Update selected MonitoringSystem
   * @param prop
   * @param value
   */
  const updateSelectedMonitoringSystem = (prop: string, value: any) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (subObj.isGlobalMode == true) {
        const monitoringSystem: IPrivateSectorSuccessFactorsMonitoringSystem | undefined = subObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.find((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => p.isActive);

        if (monitoringSystem) {
          (monitoringSystem as any)[prop] = value;
          callSetState(obj);
        }
      }
      else {
        const monitoringSystem: IPrivateSectorSuccessFactorsMonitoringSystem | undefined = subCountryObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.find((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => p.isActive);

        if (monitoringSystem) {
          (monitoringSystem as any)[prop] = value;
          monitoringSystem.report_id = obj.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID];
          if (localState.selectedCountryId != undefined && localState.selectedCountryId != null && localState.selectedCountryId != '') {
            monitoringSystem.country_id = localState.selectedCountryId;
          }
          if (localState.selectedCountryIndicator != undefined && localState.selectedCountryIndicator != null && localState.selectedCountryIndicator != '') {
            monitoringSystem.country_name = localState.selectedCountryIndicator;
          }
          callSetState(obj);
        }
      }
    }
  }

  /**
   * Get selected MonitoringSystem
   * @returns
   */
  const getSelectedMonitoringSystem = (): IPrivateSectorSuccessFactorsMonitoringSystem | undefined => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subObjCPS: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (subObj.isGlobalMode) {
        return subObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.find((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => p.isActive);
      }
      else {
        // if (subObjCPS.privateSectorMonitoringTab!.privateSectorMonitoringSystems.length > 0) {
        //   subObjCPS.privateSectorMonitoringTab!.privateSectorMonitoringSystems[0].isActive = true;
        // }
        return subObjCPS.privateSectorMonitoringTab.privateSectorMonitoringSystems.find((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => p.isActive && p.country_id == localState.selectedCountryId);
      }
    }

    return undefined;
  }

  /**
   * Get selected FinancialFlows
   * @returns
   */
  const getSelectedFinancialFlows = (): IPrivateSectorSuccessFactorsFinancialFlow | undefined => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      //const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subObjCPS: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      return subObjCPS.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure!.find((p: IPrivateSectorSuccessFactorsFinancialFlow, i: number) => p.country_id == localState.selectedCountryId);

    }

    return undefined;
  }

  /**
   * Set current MonitoringSystem index
   * @param i
   */
  const setCurrentMonitoringSystemIndex = (i: number, objId: any) => {
    const obj: ILocalState = { ...localState };
    obj.currentDeleteMonitoringSystemIndex = i;
    obj.deleteMonitorSystemId = objId;
    if (i == -1) {
      selectMonitoringSystem(0, -1);
    }
    setTheLocalState(obj);
  }

  /**
   * Handle planning status change
   * @param date
   */
  const handleSystemTrackChange = (items: MultiValue<{ label: string | undefined, value: string | undefined }>) => {
    updateSelectedMonitoringSystem('track_list', items && items.length ? items.map(i => i.value).join(',') : '');

    const obj: ILocalState = { ...localState };
    obj.otherSystemTrackEnabled = items && items.some((i: any) => i.value === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
    setTheLocalState(obj);
  }

  /**
   * Handle policy dialog
   */
  const handleRevertToGlobalDialogClose = () => setRevertToGlobalDialogShow(false);
  const handleRevertToGlobalDialogShow = () => setRevertToGlobalDialogShow(true);
  const handleRevertToGlobalConfirmRevert = () => {
    handleBreakdownOrRvertReportConfirm();
    handleRevertToGlobalDialogClose();
  }

  /**
   * Handle breakdown or revert report
   */
  const handleBreakdownOrRvertReportClick = async () => {
    handleRevertToGlobalDialogShow();
  }

  /**
   * Handle breakdown or revert report confirm
   */
  const handleBreakdownOrRvertReportConfirm = async () => {
    //  const selMode = document.querySelectorAll('.spnGlobal');
    //const selMode2 = document.querySelectorAll('.spnCountry');

    // if (selMode.length > 0) {
    //   props.state.privateSectorSuccessFactorsTab!.isGlobalMode = true;
    // }

    let features: IFeature[] = [];
    //let countryLevel: boolean = true;

    // 1) Global mode
    if (props.state.privateSectorSuccessFactorsTab?.isGlobalMode) {
      let objFund =
      {
        isActive: false,
        report_id: '',
        type: '',
        OBJECTID: -1,
        country_name: '',
        amount: 0,
        tier: '',
        sources: '',
        financial_support_used: '',
        financial_support_used_other: '',
        financial_support_contribute: '',
        country_id: ''
      }
      // Country level 
      const countries: IFeature[] = await QueryService.queryGADMFeatures(ConfigService.getConfig().agol.gadmLayers.gadm_0.index, `${ConfigService.getConfig().agol.gadmLayers.gadm_0.fields.name0} ASC`);
      let selectedCountries: IFeature[] = [];
      let selectedFunCountries: IFeature[] = [];
      // Country level
      let i = 0;
      props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators.forEach((el: IReportCountriesIndicators) => {
        countries.map((country: IFeature) => {
          const report: any | undefined = (el.country_indicator == country.attributes['NAME_0']);
          //const report: any | undefined = (el.country_id == country.attributes['GID_0']);
          if (report == true) {
            selectedCountries[i] = (JSON.parse(JSON.stringify(country)));
            if (el.action_indicator?.indexOf('3') != -1) {
              selectedFunCountries[i] = (JSON.parse(JSON.stringify(country.attributes['GID_0'])));
              const res = props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab!.totalDomesticPublicExpenditure!.find((ifun: any) => ifun.country_id == selectedFunCountries[i])
              if (res === undefined) {
                objFund.report_id = (el.report_id == undefined ? '' : el.report_id);
                objFund.country_id = country.attributes['GID_0'];
                objFund.country_name = country.attributes['NAME_0'];               
                props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab!.totalDomesticPublicExpenditure!.push((JSON.parse(JSON.stringify(objFund))));
                //props.state.countriesPrivateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab?.totalDomesticPublicExpenditure!.push(objFund);
              }
            }
            i = i + 1;
          }
        });
      });


      features = selectedCountries;


      if (features.length) {
        props.state.privateSectorSuccessFactorsTab!.isGlobalMode = false;
        addResultsAndBenefitsItem(true, features);
        loadContentData(props.state.countriesPrivateSectorSuccessFactorsTab!, false);
      }
      // if (selMode2.length > 0) 
      // {
      //   props.state.privateSectorSuccessFactorsTab!.isGlobalMode = false;
      // }

    }

    // 2) Breakpoint mode
    else {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      addResultsAndBenefitsItem(true);
      props.state.privateSectorSuccessFactorsTab!.isGlobalMode = true;
      //localState.selectedCountryId = '';
      //localState.selectedCountryIndicator = '';
      loadContentData(props.state.privateSectorSuccessFactorsTab!, false);
      enableDisableTabs(props.state.restorationPledgeTrackingDetailsTab?.location_specific, '');
    }
  }

  /**
   * Add new results and benefits Item
   * @param clearItems 
   * @param features
   */
  const addResultsAndBenefitsItem = (clearItems: boolean = false, features: IFeature[] = Object.create(null)) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subTab: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const rbTab: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      const restorePlegdeDetailTab: IRestorationPledgeTrackingDetailsTab = { ...obj.restorationPledgeTrackingDetailsTab } as IRestorationPledgeTrackingDetailsTab;
      const items = features && features.length ? features.reverse().map((feat: IFeature, i: number) => initRBItem(feat)) : [];
      const oneItem: ICountriesPrivateSectorSuccessFactorsTab = items && items.length ? items.reverse()[0] : initRBItem(Object.create(null));

      const oneItem1: any = oneItem;

      // Is Global
      if (oneItem.gid1) {
        subTab.isGlobalMode = false;
      } else {
        subTab.isGlobalMode = true;
      }

      if(restorePlegdeDetailTab.location_specific == '1')
      {
      //Clear items
      //if (clearItems) {
      if (!subTab.isGlobalMode) {
        // Store delete objects ids
        //setDeleteObjectids(rbTab);

        //rbTab.privateSectorSuccessFactorItems!.policiesAndStrategiesTab!.policiesAndStrategies = [];    
        //rbTab.privateSectorSuccessFactorItems = [];
        restorePlegdeDetailTab?.sectorReportCountries.privateSectorReportCountriesIndicators.forEach((el: IReportCountriesIndicators, i: number) => {
          if (el.country_id == oneItem.gid1) {
            el.isActive = true;
          }
          else {
            el.isActive = false;
          }
        })
      }
      
      if(oneItem.sectorReportCountries.length > 0)
      {
        oneItem.sectorReportCountries[0].isActive = true;
        oneItem.gid1 = oneItem.sectorReportCountries[0].country_id;
      }

      obj.countriesPrivateSectorSuccessFactorsTab! = oneItem; //rbTab;
      if (oneItem != null && oneItem != undefined) {
        let polActiveFlag = false;
        let planActiveFlag = false;
        let msActiveFlag = false;
        localState.selectedCountryId = oneItem.sectorReportCountries[0].country_id;
        localState.selectedCountryIndicator = oneItem.sectorReportCountries[0].country_indicator;
        oneItem!.policiesAndStrategiesTab!.policiesAndStrategies.forEach((Item: ISuccessFactorsPolicyStrategies, i: number) => {
          if (Item.country_id == oneItem.gid1 && !polActiveFlag) {
            Item.isActive = true;
            polActiveFlag = true;
          }
          else {
            Item.isActive = false;
          }
        })
        oneItem!.privateSectorTechnicalPlanningTab!.privateSectorPlanningMethodologies.forEach((Item: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) => {
          if (Item.country_id == oneItem.gid1 && !planActiveFlag) {
            Item.isActive = true;
            planActiveFlag = true;
          }
          else {
            Item.isActive = false;
          }
        })
        oneItem!.privateSectorMonitoringTab!.privateSectorMonitoringSystems.forEach((Item: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) => {
          if (Item.country_id == oneItem.gid1 && !msActiveFlag) {
            Item.isActive = true;
            msActiveFlag = true;
          }
          else {
            Item.isActive = false;
          }
        })
      }
      obj.privateSectorSuccessFactorsTab! = subTab;
    }
    else
    {
      subTab.isGlobalMode = true;
      obj.privateSectorSuccessFactorsTab! = subTab;
    }

      // Validate data
      props.validateData(rbTab, restorePlegdeDetailTab);

      props.setState(obj);

    }
  }

  /**
   * Init results and benefits item
   * @param feature
   * @returns
   */
  const initRBItem = (feature: IFeature = Object.create(null)) => {
    const atts: any = feature ? feature.attributes : null;
    const item: ICountriesPrivateSectorSuccessFactorsTab = {
      isActive: true,
      isOK: false,
      //isGlobalMode:false,    
      //name1: atts ? atts[ConfigService.getConfig().agol.gadmLayers.gadm_0.fields.name0] : undefined,
      gid1: atts ? atts[ConfigService.getConfig().agol.gadmLayers.gadm_0.fields.gid0] : undefined,
      OBJECTID: -1,
      report_id: props.state.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID],
      policiesAndStrategiesTab: {
        policiesAndStrategies: props.state.countriesPrivateSectorSuccessFactorsTab?.policiesAndStrategiesTab?.policiesAndStrategies!,
        deleteObjetIds: props.state.countriesPrivateSectorSuccessFactorsTab!.policiesAndStrategiesTab!.deleteObjetIds!
      },
      privateSectorTechnicalPlanningTab: {
        privateSectorPlanningMethodologies: props.state.countriesPrivateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab?.privateSectorPlanningMethodologies!,
        deleteObjetIds: props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab!.deleteObjetIds!
      },
      privateSectorFinancialFlowsTab: {
        totalDomesticPublicExpenditure: props.state.countriesPrivateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab?.totalDomesticPublicExpenditure!,
        deleteObjetIds: props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab!.deleteObjetIds!
      },
      privateSectorMonitoringTab: {
        privateSectorMonitoringSystems: props.state.countriesPrivateSectorSuccessFactorsTab?.privateSectorMonitoringTab?.privateSectorMonitoringSystems!,
        deleteObjetIds: props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorMonitoringTab!.deleteObjetIds!
      },
      sectorReportCountries: props.state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators
    }

    return item;
  }

  const handlePolicyDialogClose = () => setPolicyDialogShow(false);
  const handlePolicyDialogShow = () => setPolicyDialogShow(true);
  const handlePolicyConfirmDelete = () => {
    if (props.state && localState.currentDeletePolicyIndex > -1) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      if (subObj.isGlobalMode == true) {
        subObj.policiesAndStrategiesTab.policiesAndStrategies.splice(localState.currentDeletePolicyIndex, 1);
      }
      else {
        const objWithIdIndex = subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.findIndex((item: ISuccessFactorsPolicyStrategies) => item.OBJECTID == localState.deletePolicyId);
        if (objWithIdIndex > -1) {
          subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.splice(objWithIdIndex, 1);
        }
        //subCountryObj.policiesAndStrategiesTab.policiesAndStrategies.filter((item: ISuccessFactorsPolicyStrategies) => item.OBJECTID == localState.deletePolicyId).splice(localState.currentDeletePolicyIndex, 1);
      }
      callSetState(obj);
    }

    setCurrentPolicyIndex(-1, localState.deletePolicyId);
    handlePolicyDialogClose();
  }

  /**
   * Handle PlanningMethodology dialog
   */
  const handlePlanningMethodologyDialogClose = () => setPlanningMethodologyDialogShow(false);
  const handlePlanningMethodologyDialogShow = () => setPlanningMethodologyDialogShow(true);
  const handlePlanningMethodologyConfirmDelete = () => {
    if (props.state && localState.currentDeletePlanningMethodologyIndex > -1) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;

      if (subObj.isGlobalMode == true) {
        subObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.splice(localState.currentDeletePlanningMethodologyIndex, 1);
      }
      else {
        const objWithIdIndex = subCountryObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.findIndex((item: IPrivateSectorSuccessFactorsPlanningMethodology) => item.OBJECTID == localState.deleteTechPlanId);
        if (objWithIdIndex > -1) {
          subCountryObj.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.splice(objWithIdIndex, 1);
        }
      }
      callSetState(obj);
    }

    setCurrentPlanningMethodologyIndex(-1, localState.deleteTechPlanId);
    handlePlanningMethodologyDialogClose();
  }

  /**
   * Handle MonitoringSystem dialog
   */
  const handleMonitoringSystemDialogClose = () => setMonitoringSystemDialogShow(false);
  const handleMonitoringSystemDialogShow = () => setMonitoringSystemDialogShow(true);
  const handleMonitoringSystemConfirmDelete = () => {
    if (props.state && localState.currentDeleteMonitoringSystemIndex > -1) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IPrivateSectorSuccessFactorsTab = { ...obj.privateSectorSuccessFactorsTab } as IPrivateSectorSuccessFactorsTab;
      const subCountryObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      if (subObj.isGlobalMode == true) {
        subObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.splice(localState.currentDeleteMonitoringSystemIndex, 1);
      }
      else {
        const objWithIdIndex = subCountryObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.findIndex((item: IPrivateSectorSuccessFactorsMonitoringSystem) => item.OBJECTID == localState.deleteMonitorSystemId);
        if (objWithIdIndex > -1) {
          subCountryObj.privateSectorMonitoringTab.privateSectorMonitoringSystems.splice(objWithIdIndex, 1);
        }
      }
      callSetState(obj);
    }

    setCurrentMonitoringSystemIndex(-1, localState.deleteMonitorSystemId);
    handleMonitoringSystemDialogClose();
  }

  /**
   * Check if a field is required in policy tab
   * @param field
   */
  const isRequiredPolicy = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportPolicies.sectorRequiredFields, field);
  }

  /**
   * Check if a field is required in financial flow tab
   * @param field
   */
  const isRequiredFinFlow = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportFinancialFlows.psRequiredFields, field);
  }

  /**
   * Check if a field is required in technical planning tab
   * @param field
   */
  const isRequiredTechPlan = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportTechnicalPlanning.psRequiredFields, field);
  }

  /**
   * Check if a field is required in monitoring tab
   * @param field
   */
  const isRequiredMonitoring = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportMonitoring.psRequiredFields, field);
  }

  const handleEditorRevpolicy = (state: any) => {
    seteditorStateRevpolicy(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateRevpolicy.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedPolicy('information', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorOthInfo = (state: any) => {    
    seteditorStateOthInfo(state);
    //setisMaxCount(false);
    //Utils.setStateValue('isMaxCount', false, state, useState);    
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateOthInfo.getCurrentContent()))
    );    
    
    // if(currentContentAsHTML.length > MAX_LENGTH)
    // {
    //   currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);
    //   //setisMaxCount(true);
    //   Utils.setStateValue('isMaxCount', true, state, useState);           
    //   toast.error(t('newReport.reportAlreadyExists')); 
    // }

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }
        
    updateSelectedPolicy('responsible', Utils.trimWhiteSpace(currentContentAsHTML))  
  };
    
  const handleEditorPolyCit = (state: any) => {
    seteditorStatePolyCit(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStatePolyCit.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedPolicy('links', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorMethodology = (state: any) => {
    seteditorStateMethodology(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateMethodology.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedPlanningMethodology('methodology', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorExplanation = (state: any) => {
    seteditorStateExplanation(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateExplanation.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedPlanningMethodology('explanation', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorRevLink = (state: any) => {
    seteditorStateRevLink(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateRevLink.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedPlanningMethodology('links', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorFinContr = (state: any) => {
    seteditorStateFinContr(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateFinContr.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    setFinancialFlowsState(0, 'financial_support_contribute', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorSrc = (state: any) => {
    seteditorStateSrc(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateSrc.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    setFinancialFlowsState(0, 'sources', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorMonSys = (state: any) => {
    seteditorStateMonSys(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateMonSys.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedMonitoringSystem('monitoring_system', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorMonContr = (state: any) => {
    seteditorStateMonContr(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateMonContr.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }

    updateSelectedMonitoringSystem('information', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  const handleEditorMonCit = (state: any) => {
    seteditorStateMonCit(state);
    let currentContentAsHTML = JSON.stringify(
      draftToHtml(convertToRaw(editorStateMonCit.getCurrentContent()))
    );

    if(Utils.removeHTMLTag(currentContentAsHTML).length > MAX_LENGTH)
    {
      currentContentAsHTML = currentContentAsHTML.slice(0, MAX_LENGTH);     
    }
    
    updateSelectedMonitoringSystem('links', Utils.trimWhiteSpace(currentContentAsHTML))
  };

  /**
 * Select results and benefits Item
 * @param index 
 */
  const selectResultsAndBenefitsItem = (index: number) => {
    if (props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: ICountriesPrivateSectorSuccessFactorsTab = { ...obj.countriesPrivateSectorSuccessFactorsTab } as ICountriesPrivateSectorSuccessFactorsTab;
      let selectectItem: IReportCountriesIndicators = Object.create(null);
      let selectedData: any;
      let selActionTab: any = '1';
      subObj.sectorReportCountries.forEach((p: IReportCountriesIndicators, i: number) => {
        p.isActive = i === index;

        if (i === index) {
          selectectItem = p;
        }
      });

      localState.selectedCountryIndicator = selectectItem.country_indicator!;
      localState.selectedCountryId = selectectItem.country_id!;
      // if (selectectItem.action_indicator?.indexOf(',') !== -1) {        
      //   selActionTab = selectectItem.action_indicator?.split(',')[0].toString();
      // }
      // else {
      //   selActionTab = selectectItem.action_indicator?.toString();
      // }
      let isSelectedFlag = false;
      if (selectectItem.action_indicator?.indexOf('1') != -1 && !isSelectedFlag) {
        isSelectedFlag = true;
        selActionTab = '1';
        props.state.countriesPrivateSectorSuccessFactorsTab!.policiesAndStrategiesTab.policiesAndStrategies.map((act: ISuccessFactorsPolicyStrategies) => {
          act.isActive = false;
        });
        selectedData = props.state.countriesPrivateSectorSuccessFactorsTab!.policiesAndStrategiesTab.policiesAndStrategies.find((ele: ISuccessFactorsPolicyStrategies) => ele.country_id == localState.selectedCountryId);
      }
      else if (selectectItem.action_indicator?.indexOf('2') != -1 && !isSelectedFlag) {
        isSelectedFlag = true;
        selActionTab = '2';
        props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.map((act: IPrivateSectorSuccessFactorsPlanningMethodology) => {
          act.isActive = false;
        });
        selectedData = props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.find((ele: IPrivateSectorSuccessFactorsPlanningMethodology) => ele.country_id == localState.selectedCountryId);
      }
      else if (selectectItem.action_indicator?.indexOf('3') != -1 && !isSelectedFlag) {
        isSelectedFlag = true;
        selActionTab = '3';
        selectedData = props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab!.totalDomesticPublicExpenditure?.find((ele: IPrivateSectorSuccessFactorsFinancialFlow) => ele.country_id == localState.selectedCountryId);
      }
      else if (selectectItem.action_indicator?.indexOf('4') != -1 && !isSelectedFlag) {
        isSelectedFlag = true;
        selActionTab = '4';
        props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorMonitoringTab.privateSectorMonitoringSystems.map((act: IPrivateSectorSuccessFactorsMonitoringSystem) => {
          act.isActive = false;
        });
        selectedData = props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorMonitoringTab.privateSectorMonitoringSystems.find((ele: IPrivateSectorSuccessFactorsMonitoringSystem) => ele.country_id == localState.selectedCountryId);
      }
      if(selActionTab != '2' && props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab!.privateSectorPlanningMethodologies!.length >0)
      {
        let isTechActive = false;
        props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.map((ele: IPrivateSectorSuccessFactorsPlanningMethodology) => {          
          ele.isActive=false;
          if(ele.country_id == localState.selectedCountryId && !isTechActive)
          {
            ele.isActive=true;
            isTechActive = true;
          }
        });         
      }
      if(selActionTab != '3' && props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab!.totalDomesticPublicExpenditure!.length >0)
      {
        props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab!.totalDomesticPublicExpenditure?.find((ele: IPrivateSectorSuccessFactorsFinancialFlow) => ele.country_id == localState.selectedCountryId);        
      }
      if(selActionTab != '4' && props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorMonitoringTab.privateSectorMonitoringSystems!.length >0)
      {
        let isMonitorActive = false;
        props.state.countriesPrivateSectorSuccessFactorsTab!.privateSectorMonitoringTab.privateSectorMonitoringSystems.map((ele: IPrivateSectorSuccessFactorsMonitoringSystem) => {
          ele.isActive=false;
          if(ele.country_id == localState.selectedCountryId && !isMonitorActive)
          {
            ele.isActive=true;
            isMonitorActive = true;
          }
        });        
      }

      if (selectedData == undefined) {
        if (selActionTab == '1') {
          addNewPolicy();
        }
        if (selActionTab == '2') {
          addNewPlanningMethodology();
        }
        if (selActionTab == '4') {
          addNewMonitoringSystem();
        }
        loadAddNewContentData();
      }
      else {
        selectedData.isActive = true;
        loadContentData(selectedData, true);
      }

      enableDisableTabs(props.state.restorationPledgeTrackingDetailsTab?.location_specific, selectectItem);

      props.setState(obj);
    }
  }
  

  return (
    <div className="oneTabContent successFactorsTab sectorsuccessFactorsTab row">
      <div className="itemsLeft">
        <div className="breakdownReportByStatesDiv breakdownsectorReportByCountryDiv">
          <button className="actionBtn primary" onClick={handleBreakdownOrRvertReportClick}>
            {props.state.privateSectorSuccessFactorsTab?.isGlobalMode && <span className='spnMode spnCountry'>{t('newReport.resultsAndBenefits.breakdownReportByCountries')}</span>}
            {!props.state.privateSectorSuccessFactorsTab?.isGlobalMode && <span className='spnMode spnGlobal'>{t('newReport.resultsAndBenefits.revertToCompanyReport')}</span>}
          </button>
        </div>

        {!props.state.privateSectorSuccessFactorsTab?.isGlobalMode &&
          <div className="itemsList">
            {props.state.countriesPrivateSectorSuccessFactorsTab?.sectorReportCountries.map((p: any, i: number) =>
              <div className={`oneItem ${p.isActive ? 'active' : p.isOK ? 'ok' : 'default'}`} key={i} onClick={() => { selectResultsAndBenefitsItem(i) }}>
                <span className="tabSpan">{p.country_indicator}</span>
                {!p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={p.isOK ? faCheck : faTimes} />}

                {p.isActive &&
                  <div className="oneItemContent">
                    <p className={`subTabItem ${p.isActive && (p.action_indicator.indexOf('1') != -1) && 'ok'}`}>
                      <span className="commonText">1. {t('newReport.successFactors.policiesAndInstitLabel')}</span>
                      {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={(p.action_indicator.indexOf('1') != -1) ? faCheck : faTimes} />}
                    </p>

                    <p className={`subTabItem ${p.isActive && (p.action_indicator.indexOf('2') != -1) && 'ok'}`}>
                      <span className="commonText">2. {t('newReport.successFactors.technicalPlanningLabel')}</span>
                      {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={(p.action_indicator.indexOf('2') != -1) ? faCheck : faTimes} />}
                    </p>

                    <p className={`subTabItem ${p.isActive && (p.action_indicator.indexOf('3') != -1) && 'ok'}`}>
                      <span className="commonText">3. {t('newReport.successFactors.financialFlowsLabel')}</span>
                      {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={(p.action_indicator.indexOf('3') != -1) ? faCheck : faTimes} />}
                    </p>

                    <p className={`subTabItem ${p.isActive && (p.action_indicator.indexOf('4') != -1) && 'ok'}`}>
                      <span className="commonText">4. {t('newReport.successFactors.monitoringLabel')}</span>
                      {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={(p.action_indicator.indexOf('4') != -1) ? faCheck : faTimes} />}
                    </p>
                  </div>
                }

              </div>
            )}
          </div>
        }
      </div>
      <div className="itemsRight">
        <div className="successFactorsTabs">
          <div className={`oneTabItem ${localState.policiesAndStrategiesTab.isActive ? 'active' : localState.policiesAndStrategiesTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(0)}>{'1. ' + t('newReport.successFactors.policiesAndInstitLabel')}</div>
          <div className={`oneTabItem ${localState.privateSectorTechnicalPlanningTab.isActive ? 'active' : localState.privateSectorTechnicalPlanningTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(1)}>{'2. ' + t('newReport.successFactors.technicalPlanningLabel')}</div>
          <div className={`oneTabItem ${localState.privateSectorFinancialFlowsTab.isActive ? 'active' : localState.privateSectorFinancialFlowsTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(2)}>{'3. ' + t('newReport.successFactors.financialFlowsLabel')}</div>
          <div className={`oneTabItem ${localState.privateSectorMonitoringTab.isActive ? 'active' : localState.privateSectorMonitoringTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(3)}>{'4. ' + t('newReport.successFactors.monitoringLabel')}</div>
        </div>

        <div className="successFactorsContent">
          <div className="borderHider">
            <div className={`oneBorderHider ${localState.policiesAndStrategiesTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.privateSectorTechnicalPlanningTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.privateSectorFinancialFlowsTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.privateSectorMonitoringTab.isActive ? 'active' : ''}`}></div>
          </div>

          { /* policiesAndInstitTab */}
          {localState.policiesAndStrategiesTab.isActive &&
            <div className="oneTabContent">
              <div className="oneTabContentNote">
                <span className="oneTabIntroText co2SequesteredFormula marginbtm10">{t('newReport.successFactors.chosenIndicators')}</span>
              </div>
              <div className="oneTabIntro">
                <div className="oneTabIntroNumAndTitle">
                  <span className="oneTabIntroNumber">1</span>
                  <span className="oneTabIntroTitle">{t('newReport.successFactors.policiesAndInstitLabel')}</span>
                </div>

                {/* <p className="oneTabIntroText">{t('newReport.successFactors.policiesAndInstitIntro')}</p> */}
              </div>

              <div className="itemsDiv">
                {props.state.privateSectorSuccessFactorsTab?.isGlobalMode &&
                  <div className="itemsleft itemsleftbtndiv">
                    <div className="addItemDiv">
                      <button className="actionBtn primary" onClick={addNewPolicy}>&nbsp;&nbsp;
                        <span>{t('newReport.successFactors.AddNew')}</span>
                        <FontAwesomeIcon className="plusIcon" icon={faPlus} />
                      </button>
                    </div>

                    <div className="itemsList marginLeft10">
                      {props.state.privateSectorSuccessFactorsTab?.policiesAndStrategiesTab.policiesAndStrategies.map((p: ISuccessFactorsPolicyStrategies, i: number) =>
                        <div className={`oneItem oneItemInner ${p.isActive ? 'active' : 'default'}`} key={i} onClick={() => { selectPolicy(i, p.OBJECTID) }}>
                          <span className="tabSpan tabSpanEllipsis" title={Utils.removeHTMLTag(p.information)}>{Utils.removeHTMLTag(p.information)}</span>
                          <FontAwesomeIcon className="tabIcon deleteIcon oneitemBtn" icon={faTrash} onClick={(e) => { deletePolicy(e, i, p.OBJECTID) }} />
                        </div>
                      )}
                    </div>

                  </div>
                }

                {props.state.privateSectorSuccessFactorsTab?.isGlobalMode !== true &&
                  <div className="itemsleft itemsleftbtndiv">
                    <div className="addItemDiv">
                      <button className="actionBtn primary" onClick={addNewPolicy}>&nbsp;&nbsp;
                        <span>{t('newReport.successFactors.AddNew')}</span>
                        <FontAwesomeIcon className="plusIcon" icon={faPlus} />
                      </button>
                    </div>

                    <div className="itemsList marginLeft10">
                      {props.state.countriesPrivateSectorSuccessFactorsTab?.policiesAndStrategiesTab.policiesAndStrategies.filter((f: ISuccessFactorsPolicyStrategies) => f.country_id == localState.selectedCountryId).map((p: ISuccessFactorsPolicyStrategies, i: number) =>
                        <div className={`oneItem oneItemInner ${p.isActive ? 'active' : 'default'}`} key={i} onClick={() => { selectPolicy(i, p.OBJECTID) }}>
                          <span className="tabSpan tabSpanEllipsis" title={Utils.removeHTMLTag(p.information)}>{Utils.removeHTMLTag(p.information)}</span>
                          <FontAwesomeIcon className="tabIcon deleteIcon oneitemBtn" icon={faTrash} onClick={(e) => { deletePolicy(e, i, p.OBJECTID) }} />
                        </div>
                      )}
                    </div>

                  </div>
                }

                {props.state.privateSectorSuccessFactorsTab?.isGlobalMode && getSelectedPolicy() &&
                  <div className="itemsRight itemsRightInner">
                    <div className="onePolicyRow row">{ }
                      <span className="titleSpan mediumText">15a. {t('newReport.successFactors.relevantpoliciesstrategies')}</span>
                      <div className={`alEditorDiv  ${isRequiredPolicy('information') ? "requiredField" : ""}`}>
                        <Editor
                          editorState={editorStateRevpolicy}
                          onEditorStateChange={handleEditorRevpolicy}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          toolbar={{
                            options: ['link'],
                            link: { inDropdown: true },
                          }}
                        />
                      </div>
                      {/* <p> */}
                      {/* <input className="mediumText big unsetMaxWidth" type="text" required={isRequiredPolicy('information')}
                          maxLength={9999}
                          placeholder={t('newReport.successFactors.relevantpoliciesstrategiesPlaceholder')} value={getSelectedPolicy()?.information || ''} onChange={(e) => { updateSelectedPolicy('information', e.target.value) }} /> */}

                      {/* <textarea className="commonText medium" required={isRequiredPolicy('information')}
                        maxLength={Utils.getFieldInfos(localState.reportPoliciesLayerIndex, 'information')?.length || 9999}
                        rows={5} placeholder={t('newReport.successFactors.relevantpoliciesstrategiesPlaceholder')} value={getSelectedPolicy()?.information || ''} onChange={(e) => { updateSelectedPolicy('information', e.target.value) }} />  */}
                      {/* </p> */}
                    </div>
                    <div className="onePolicyRow row">
                      <span className="titleSpan mediumText">15b. {t('newReport.successFactors.otherInfo')}</span>
                      <div className="alEditorDiv">
                        <Editor
                          editorState={editorStateOthInfo}
                          onEditorStateChange={handleEditorOthInfo}                            
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"                          
                          toolbar={{
                            options: ['link'],
                            link: { inDropdown: true },
                          }}
                        />
                      </div>
                      {/* <p><textarea className="commonText medium" required={isRequiredPolicy('responsible')}
                        maxLength={Utils.getFieldInfos(localState.reportPoliciesLayerIndex, 'responsible')?.length || 9999}
                        rows={5} placeholder={t('newReport.successFactors.otherInfoPlaceholder')} value={getSelectedPolicy()?.responsible || ''} onChange={(e) => { updateSelectedPolicy('responsible', e.target.value) }} /> </p> */}
                    </div>

                    <div className="onePolicyRow row">
                      <span className="titleSpan mediumText">15c. {t('newReport.successFactors.policiesCitations')}</span>
                      <div className={`alEditorDiv  ${isRequiredPolicy('links') ? "requiredField" : ""}`}>
                        <Editor
                          editorState={editorStatePolyCit}
                          onEditorStateChange={handleEditorPolyCit}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          toolbar={{
                            options: ['link'],
                            link: { inDropdown: true }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                }


                {!props.state.privateSectorSuccessFactorsTab?.isGlobalMode && getSelectedPolicy() &&
                  <div className="itemsRight itemsRightInner">
                    <div className="onePolicyRow row">{ }
                      <span className="titleSpan mediumText">15a. {t('newReport.successFactors.relevantpoliciesstrategies')}</span>
                      <div className={`alEditorDiv  ${isRequiredPolicy('information') ? "requiredField" : ""}`}>
                        <Editor
                          editorState={editorStateRevpolicy}
                          onEditorStateChange={handleEditorRevpolicy}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          toolbar={{
                            options: ['link'],
                            link: { inDropdown: true },
                          }}
                        />
                      </div>

                      {/* <input className="mediumText big unsetMaxWidth" type="text" required={isRequiredPolicy('information')}
                          maxLength={9999}
                          placeholder={t('newReport.successFactors.relevantpoliciesstrategiesPlaceholder')} value={getSelectedPolicy()?.information || ''} onChange={(e) => { updateSelectedPolicy('information', e.target.value) }} /> */}


                    </div>
                    <div className="onePolicyRow row">
                      <span className="titleSpan mediumText">15b. {t('newReport.successFactors.otherInfo')}</span>
                      <div className="alEditorDiv">
                        <Editor
                          editorState={editorStateOthInfo}
                          onEditorStateChange={handleEditorOthInfo}                           
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          toolbar={{
                            options: ['link'],
                            link: { inDropdown: true },
                          }}
                        />
                      </div>
                    </div>

                    <div className="onePolicyRow row">
                      <span className="titleSpan mediumText">15c. {t('newReport.successFactors.policiesCitations')}</span>
                      <div className={`alEditorDiv  ${isRequiredPolicy('links') ? "requiredField" : ""}`}>
                        <Editor
                          editorState={editorStatePolyCit}
                          onEditorStateChange={handleEditorPolyCit}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                          toolbar={{
                            options: ['link'],
                            link: { inDropdown: true }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }


          { /* technicalPlanningTab */}
          <div className={`oneTabContent technicalPlanningTab ${!localState.privateSectorTechnicalPlanningTab.isActive && 'hidden'}`}>
            <div className="oneTabIntro">
              <div className="oneTabIntroNumAndTitle">
                <span className="oneTabIntroNumber">2</span>
                <span className="oneTabIntroTitle">{t('newReport.successFactors.technicalPlanningLabel')}</span>
              </div>

              {/* <p className="oneTabIntroText">{t('newReport.successFactors.technicalPlanningIntro')}</p> */}
            </div>

            <div className="itemsDiv">
              {props.state.privateSectorSuccessFactorsTab?.isGlobalMode &&
                <div className="itemsleft itemsleftbtndiv">
                  <div className="addItemDiv">
                    <button className="actionBtn primary" onClick={addNewPlanningMethodology}> &nbsp;&nbsp;
                      <span>{t('newReport.successFactors.AddNew')}</span>
                      <FontAwesomeIcon className="plusIcon" icon={faPlus} />
                    </button>
                  </div>

                  <div className="itemsList marginLeft10">

                    {props.state.privateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.map((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) =>
                      <div className={`oneItem oneItemInner ${p.isActive ? 'active' : 'default'}`} key={i} onClick={() => { selectPlanningMethodology(i, p.OBJECTID) }}>
                        <span className="tabSpan tabSpanEllipsis" title={Utils.removeHTMLTag(p.methodology)}>{Utils.removeHTMLTag(p.methodology)}</span>
                        <FontAwesomeIcon className="tabIcon deleteIcon oneitemBtn" icon={faTrash} onClick={(e) => { deletePlanningMethodology(e, i, p.OBJECTID) }} />
                      </div>
                    )}
                  </div>
                </div>
              }

              {props.state.privateSectorSuccessFactorsTab?.isGlobalMode !== true &&
                <div className="itemsleft itemsleftbtndiv">
                  <div className="addItemDiv">
                    <button className="actionBtn primary" onClick={addNewPlanningMethodology}> &nbsp;&nbsp;
                      <span>{t('newReport.successFactors.AddNew')}</span>
                      <FontAwesomeIcon className="plusIcon" icon={faPlus} />
                    </button>
                  </div>

                  <div className="itemsList marginLeft10">

                    {props.state.countriesPrivateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.filter((f: IPrivateSectorSuccessFactorsPlanningMethodology) => f.country_id == localState.selectedCountryId).map((p: IPrivateSectorSuccessFactorsPlanningMethodology, i: number) =>
                      <div className={`oneItem oneItemInner ${p.isActive ? 'active' : 'default'}`} key={i} onClick={() => { selectPlanningMethodology(i, p.OBJECTID) }}>
                        <span className="tabSpan tabSpanEllipsis" title={Utils.removeHTMLTag(p.methodology)}>{Utils.removeHTMLTag(p.methodology)}</span>
                        <FontAwesomeIcon className="tabIcon deleteIcon oneitemBtn" icon={faTrash} onClick={(e) => { deletePlanningMethodology(e, i, p.OBJECTID) }} />
                      </div>
                    )}
                  </div>
                </div>
              }
              {props.state.privateSectorSuccessFactorsTab?.isGlobalMode && getSelectedPlanningMethodology() &&
                <div className="itemsRight itemsRightInner">
                  <div className="row">
                    <span className="titleSpan mediumText">16a. {t('newReport.successFactors.whichToolsMethodologies')}</span>
                    <div className={`alEditorDiv  ${isRequiredTechPlan('methodology') ? "requiredField" : ""}`}>
                      <Editor
                        editorState={editorStateMethodology}
                        onEditorStateChange={handleEditorMethodology}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <p>
                      <input className="mediumText big" type="text" required={isRequiredTechPlan('methodology')}
                        maxLength={9999}
                        placeholder={t('newReport.successFactors.whichToolsMethodologiesPlaceholder')} value={getSelectedPlanningMethodology()?.methodology || ''} onChange={(e) => { updateSelectedPlanningMethodology('methodology', e.target.value) }} />
                    </p> */}
                  </div>

                  {/* <div className="row"> */}
                  <div className={`row multiselectRow ${isRequiredTechPlan('ecosystem_resto_principles') ? "required" : ""}`}>
                    <span className="titleSpan mediumText">16b. {t('newReport.successFactors.ecosystemRestoPrinciples')}
                      <a href='https://www.decadeonrestoration.org/what-ecosystem-restoration' target='_blank'>{t('newReport.successFactors.ecosystemRestoLink')}</a>
                      {t('newReport.successFactors.ecosystemRestoPrinciple')}</span>
                    <div className="col-10">
                      <Select
                        classNamePrefix="multiselect" placeholder={t('newReport.successFactors.financialsupportPlaceholder')}
                        closeMenuOnSelect={true} isMulti
                        options={localState.refRestorationPrinciplesFeature.map((i: IRefRestorationPrinciplesFeature) => { return { label: i.value, value: i.key_ } })}
                        onChange={handleRestorationPrinciplesChange}
                        value={
                          localState.refRestorationPrinciplesFeature.map((i: IRefRestorationPrinciplesFeature) => { return { label: i.value, value: i.key_ } })
                            .filter(option => (getSelectedPlanningMethodology()?.ecosystem_resto_principles || '').split(',').indexOf(option.value || '---') !== -1)
                        } />
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">16c. {t('newReport.successFactors.restorationplanning')}</span>
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateExplanation}
                        onEditorStateChange={handleEditorExplanation}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <textarea className="commonText big" required={isRequiredTechPlan('explanation')}
                        maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'explanation')?.length || 9999}
                        rows={5} placeholder={t('newReport.successFactors.restorationplanningPlaceholder')} value={getSelectedPlanningMethodology()?.explanation || ''} onChange={(e) => { updateSelectedPlanningMethodology('explanation', e.target.value) }} /> */}
                  </div>

                  {/* <div className="row"> */}
                  <div className={`row ${isRequiredTechPlan('links') ? "required" : ""}`}>
                    <span className="titleSpan mediumText">16d. {t('newReport.successFactors.relevantCitations')}</span>
                    <div className={`alEditorDiv ${isRequiredTechPlan('links') ? "requiredField" : ""}`} >
                      <Editor
                        editorState={editorStateRevLink}
                        onEditorStateChange={handleEditorRevLink}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <textarea className="commonText big" required={isRequiredTechPlan('links')}
                        maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'links')?.length || 9999}
                        rows={5} placeholder={t('newReport.successFactors.relevantCitationsPlaceholder')} value={getSelectedPlanningMethodology()?.links || ''} onChange={(e) => { updateSelectedPlanningMethodology('links', e.target.value) }} /> */}
                  </div>

                </div>
              }
              {!props.state.privateSectorSuccessFactorsTab?.isGlobalMode && getSelectedPlanningMethodology() &&
                <div className="itemsRight itemsRightInner">
                  <div className="row">
                    <span className="titleSpan mediumText">16a. {t('newReport.successFactors.whichToolsMethodologies')}</span>
                    <div className={`alEditorDiv  ${isRequiredTechPlan('methodology') ? "requiredField" : ""}`}>
                      <Editor
                        editorState={editorStateMethodology}
                        onEditorStateChange={handleEditorMethodology}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <p>
                      <input className="mediumText big" type="text" required={isRequiredTechPlan('methodology')}
                        maxLength={9999}
                        placeholder={t('newReport.successFactors.whichToolsMethodologiesPlaceholder')} value={getSelectedPlanningMethodology()?.methodology || ''} onChange={(e) => { updateSelectedPlanningMethodology('methodology', e.target.value) }} />
                    </p> */}
                  </div>

                  {/* <div className="row"> */}
                  <div className={`row multiselectRow ${isRequiredTechPlan('ecosystem_resto_principles') ? "required" : ""}`}>
                    <span className="titleSpan mediumText">16b. {t('newReport.successFactors.ecosystemRestoPrinciples')}
                      <a href='https://www.decadeonrestoration.org/what-ecosystem-restoration' target='_blank'>{t('newReport.successFactors.ecosystemRestoLink')}</a>
                      {t('newReport.successFactors.ecosystemRestoPrinciple')}</span>
                    <div className="col-10">
                      <Select
                        classNamePrefix="multiselect" placeholder={t('newReport.successFactors.financialsupportPlaceholder')}
                        closeMenuOnSelect={true} isMulti
                        options={localState.refRestorationPrinciplesFeature.map((i: IRefRestorationPrinciplesFeature) => { return { label: i.value, value: i.key_ } })}
                        onChange={handleRestorationPrinciplesChange}
                        value={
                          localState.refRestorationPrinciplesFeature.map((i: IRefRestorationPrinciplesFeature) => { return { label: i.value, value: i.key_ } })
                            .filter(option => (getSelectedPlanningMethodology()?.ecosystem_resto_principles || '').split(',').indexOf(option.value || '---') !== -1)
                        } />
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">16c. {t('newReport.successFactors.restorationplanning')}</span>
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateExplanation}
                        onEditorStateChange={handleEditorExplanation}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <textarea className="commonText big" required={isRequiredTechPlan('explanation')}
                        maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'explanation')?.length || 9999}
                        rows={5} placeholder={t('newReport.successFactors.restorationplanningPlaceholder')} value={getSelectedPlanningMethodology()?.explanation || ''} onChange={(e) => { updateSelectedPlanningMethodology('explanation', e.target.value) }} /> */}
                  </div>

                  {/* <div className="row"> */}
                  <div className={`row ${isRequiredTechPlan('links') ? "required" : ""}`}>
                    <span className="titleSpan mediumText">16d. {t('newReport.successFactors.relevantCitations')}</span>
                    <div className={`alEditorDiv ${isRequiredTechPlan('links') ? "requiredField" : ""}`} >
                      <Editor
                        editorState={editorStateRevLink}
                        onEditorStateChange={handleEditorRevLink}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <textarea className="commonText big" required={isRequiredTechPlan('links')}
                        maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'links')?.length || 9999}
                        rows={5} placeholder={t('newReport.successFactors.relevantCitationsPlaceholder')} value={getSelectedPlanningMethodology()?.links || ''} onChange={(e) => { updateSelectedPlanningMethodology('links', e.target.value) }} /> */}
                  </div>

                </div>
              }

            </div>
          </div>

          { /* financialFlowsTab */}
          <div className={`oneTabContent ${!localState.privateSectorFinancialFlowsTab.isActive && 'hidden'}`}>
            <div className="oneTabIntro">
              <div className="oneTabIntroNumAndTitle">
                <span className="oneTabIntroNumber">3</span>
                <span className="oneTabIntroTitle">{t('newReport.successFactors.financialFlowsLabel')}</span>
              </div>

              <p className="oneTabIntroText" id="financialIntroSector"></p>
            </div>

            {props.state.privateSectorSuccessFactorsTab?.isGlobalMode &&
              <div className='flowsDiv row sectorflowsDiv finFlowTop'>
                <div className="row">
                  <span className="titleSpan mediumText">17a. {t('newReport.successFactors.amount')}</span>
                  <input className="mediumText small" type="number" required={isRequiredFinFlow('amount')}
                    min={0} onKeyUp={Utils.preventNegativeValue}
                    placeholder={t('newReport.successFactors.amountPlaceholder')} value={props.state.privateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.amount || 0} onChange={(e) => { setFinancialFlowsState(0, 'amount', e.target.value) }} />
                </div>

                <div className={`row multiselectRow ${isRequiredTechPlan('landscape_status') ? "required" : ""}`}>
                  <span className="titleSpan mediumText">17b. {t('newReport.successFactors.tier')}</span>
                  <div className="marginTop10"><span className="titleSpan mediumText co2SequesteredFormula marginbtm0">{t('newReport.successFactors.tierMandatory')}</span></div>

                  <div className="col-5 singleDDLDiv marginLeft14">
                    <select className="mediumText"
                      value={props.state.privateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.tier || '-999'}
                      onChange={(e) => { setFinancialFlowsState(0, 'tier', e.target.value) }}>
                      {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                      {localState.confidenceFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                    </select>
                  </div>
                </div>

                <div className={`row multiselectRow ${isRequiredFinFlow('financial_support_used') ? "required" : ""}`}>
                  <span className="titleSpan mediumText">17c. {t('newReport.successFactors.financialsupportused')}</span>

                  <div className="col-6">
                    <Select
                      classNamePrefix="multiselect" placeholder={t('newReport.successFactors.financialsupportPlaceholder')}
                      closeMenuOnSelect={true} isMulti
                      options={localState.refFinancialSupportFeature.map((i: IRefFinancialSupportFeature) => { return { label: i.value, value: i.key_ } })}
                      onChange={handleFinancialSupportChange}
                      value={
                        localState.refFinancialSupportFeature.map((i: IRefFinancialSupportFeature) => { return { label: i.value, value: i.key_ } })
                          .filter(option => (props.state.privateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.financial_support_used || '').split(',').indexOf(option.value || 'Select') !== -1)
                      } />
                  </div>

                  <div className="col-6">
                    <input className="mediumText small right width100" required={isRequiredFinFlow('financial_support_used_other')}
                      maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'financial_support_used_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                      type="text" disabled={!localState.otherFinancialSupportInputEnabled} value={props.state.privateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.financial_support_used_other} onChange={(e) => { setFinancialFlowsState(0, 'financial_support_used_other', e.target.value) }} />
                  </div>
                </div>

                <div className="row">
                  <span className="titleSpan mediumText">17d. {t('newReport.successFactors.financialContribution')}</span>
                  <div className="alEditorDiv">
                    <Editor
                      editorState={editorStateFinContr}
                      onEditorStateChange={handleEditorFinContr}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      toolbar={{
                        options: ['link'],
                        link: { inDropdown: true },
                      }}
                    />
                  </div>
                  {/* <textarea className="commonText big"
                      maxLength={Utils.getFieldInfos(localState.reportFinancialFlowLayerIndex, 'financial_support_contribute')?.length || 9999}
                      rows={5} placeholder={t('newReport.successFactors.financialContributionPlaceholder')} value={props.state.privateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.financial_support_contribute || ''} onChange={(e) => { setFinancialFlowsState(0, 'financial_support_contribute', e.target.value) }} /> */}
                </div>

                {/* <div className="row"> */}
                <div className={`row ${isRequiredFinFlow('sources') ? "required" : ""}`}>
                  <span className="titleSpan mediumText">17e. {t('newReport.successFactors.source')}</span>
                  <div className={`alEditorDiv ${isRequiredTechPlan('links') ? "requiredField" : ""}`} >
                    <Editor
                      editorState={editorStateSrc}
                      onEditorStateChange={handleEditorSrc}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      toolbar={{
                        options: ['link'],
                        link: { inDropdown: true },
                      }}
                    />
                  </div>
                  {/* <textarea className="commonText big" required={isRequiredFinFlow('sources')}
                      maxLength={Utils.getFieldInfos(localState.reportFinancialFlowLayerIndex, 'sources')?.length || 9999}
                      rows={5} placeholder={t('newReport.successFactors.sourcePlaceholder')} value={props.state.privateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.sources || ''} onChange={(e) => { setFinancialFlowsState(0, 'sources', e.target.value) }} /> */}
                </div>
              </div>
            }

            {!props.state.privateSectorSuccessFactorsTab?.isGlobalMode &&
              <div className='flowsDiv row sectorflowsDiv finFlowTop'>
                <div className="row">
                  <span className="titleSpan mediumText">17a. {t('newReport.successFactors.amount')}</span>
                  <input className="mediumText small" type="number" required={isRequiredFinFlow('amount')}
                    min={0} onKeyUp={Utils.preventNegativeValue}
                    placeholder={t('newReport.successFactors.amountPlaceholder')} value={getSelectedFunding() == undefined ? 0 : getSelectedFunding()!.amount} onChange={(e) => { setFinancialFlowsState(0, 'amount', e.target.value) }} />
                </div>

                <div className={`row multiselectRow ${isRequiredTechPlan('landscape_status') ? "required" : ""}`}>
                  <span className="titleSpan mediumText">17b. {t('newReport.successFactors.tier')}</span>
                  <div className="marginTop10"><span className="titleSpan mediumText co2SequesteredFormula marginbtm0">{t('newReport.successFactors.tierMandatory')}</span></div>

                  <div className="col-5 singleDDLDiv marginLeft14">
                    <select className="mediumText"
                      value={getSelectedFunding() == undefined ? '-999' : getSelectedFunding()!.tier}
                      onChange={(e) => { setFinancialFlowsState(0, 'tier', e.target.value) }}>
                      {<option value="-999" key="">{t('newReport.restorationPledge.selectOnePlacehodler')}</option>}
                      {localState.confidenceFeature.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                    </select>
                  </div>
                </div>

                <div className={`row multiselectRow ${isRequiredFinFlow('financial_support_used') ? "required" : ""}`}>
                  <span className="titleSpan mediumText">17c. {t('newReport.successFactors.financialsupportused')}</span>

                  <div className="col-6">
                    <Select
                      classNamePrefix="multiselect" placeholder={t('newReport.successFactors.financialsupportPlaceholder')}
                      closeMenuOnSelect={true} isMulti
                      options={localState.refFinancialSupportFeature.map((i: IRefFinancialSupportFeature) => { return { label: i.value, value: i.key_ } })}
                      onChange={handleFinancialSupportChange}
                      value={
                        localState.refFinancialSupportFeature.map((i: IRefFinancialSupportFeature) => { return { label: i.value, value: i.key_ } })
                          .filter(option => (getSelectedFunding() == undefined ? '' : getSelectedFunding()!.financial_support_used || '').split(',').indexOf(option.value || 'Select') !== -1)
                      } />
                  </div>

                  <div className="col-6">
                    <input className="mediumText small right width100" required={isRequiredFinFlow('financial_support_used_other')}
                      maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'financial_support_used_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                      type="text" disabled={!localState.otherFinancialSupportInputEnabled}
                      value={getSelectedFunding() == undefined ? '' : getSelectedFunding()!.financial_support_used_other || ''}
                      onChange={(e) => { setFinancialFlowsState(0, 'financial_support_used_other', e.target.value) }} />
                  </div>
                </div>

                <div className="row">
                  <span className="titleSpan mediumText">17d. {t('newReport.successFactors.financialContribution')}</span>
                  <div className="alEditorDiv">
                    <Editor
                      editorState={editorStateFinContr}
                      onEditorStateChange={handleEditorFinContr}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-classgetSelectedFunding"
                      toolbarClassName="toolbar-class"
                      toolbar={{
                        options: ['link'],
                        link: { inDropdown: true },
                      }}
                    />
                  </div>
                  {/* <textarea className="commonText big"
                      maxLength={Utils.getFieldInfos(localState.reportFinancialFlowLayerIndex, 'financial_support_contribute')?.length || 9999}
                      rows={5} placeholder={t('newReport.successFactors.financialContributionPlaceholder')} value={props.state.privateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure?.financial_support_contribute || ''} onChange={(e) => { setFinancialFlowsState(0, 'financial_support_contribute', e.target.value) }} /> */}
                </div>

                {/* <div className="row"> */}
                <div className={`row ${isRequiredFinFlow('sources') ? "required" : ""}`}>
                  <span className="titleSpan mediumText">17e. {t('newReport.successFactors.source')}</span>
                  <div className={`alEditorDiv ${isRequiredTechPlan('links') ? "requiredField" : ""}`} >
                    <Editor
                      editorState={editorStateSrc}
                      onEditorStateChange={handleEditorSrc}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      toolbar={{
                        options: ['link'],
                        link: { inDropdown: true },
                      }}
                    />
                  </div>

                </div>
              </div>
            }

          </div>




          { /* monitoringTab */}
          <div className={`oneTabContent monitoringTab ${!localState.privateSectorMonitoringTab.isActive && 'hidden'}`}>
            <div className="oneTabIntro">
              <div className="oneTabIntroNumAndTitle">
                <span className="oneTabIntroNumber">4</span>
                <span className="oneTabIntroTitle">{t('newReport.successFactors.monitoringLabel')}</span>
              </div>

              {/* <p className="oneTabIntroText">{t('newReport.successFactors.monitoringIntro')}</p> */}
            </div>

            <div className="itemsDiv">
              {props.state.privateSectorSuccessFactorsTab?.isGlobalMode &&
                <div className="itemsleft itemsleftbtndiv">
                  <div className="addItemDiv">
                    <button className="actionBtn primary" onClick={addNewMonitoringSystem}> &nbsp;&nbsp;
                      <span>{t('newReport.successFactors.AddNew')}</span>
                      <FontAwesomeIcon className="plusIcon" icon={faPlus} />
                    </button>
                  </div>

                  <div className="itemsList marginLeft10">

                    {props.state.privateSectorSuccessFactorsTab?.privateSectorMonitoringTab.privateSectorMonitoringSystems.map((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) =>
                      <div className={`oneItem oneItemInner ${p.isActive ? 'active' : 'default'}`} key={i} onClick={() => { selectMonitoringSystem(i, p.OBJECTID) }}>
                        <span className="tabSpan tabSpanEllipsis" title={Utils.removeHTMLTag(p.monitoring_system)}>{Utils.removeHTMLTag(p.monitoring_system)}</span>
                        <FontAwesomeIcon className="tabIcon deleteIcon oneitemBtn" icon={faTrash} onClick={(e) => { deleteMonitoringSystem(e, i, p.OBJECTID) }} />
                      </div>
                    )}
                  </div>
                </div>
              }

              {props.state.privateSectorSuccessFactorsTab?.isGlobalMode !== true &&
                <div className="itemsleft itemsleftbtndiv">
                  <div className="addItemDiv">
                    <button className="actionBtn primary" onClick={addNewMonitoringSystem}> &nbsp;&nbsp;
                      <span>{t('newReport.successFactors.AddNew')}</span>
                      <FontAwesomeIcon className="plusIcon" icon={faPlus} />
                    </button>
                  </div>

                  <div className="itemsList marginLeft10">

                    {props.state.countriesPrivateSectorSuccessFactorsTab?.privateSectorMonitoringTab.privateSectorMonitoringSystems.filter((f: IPrivateSectorSuccessFactorsMonitoringSystem) => f.country_id == localState.selectedCountryId).map((p: IPrivateSectorSuccessFactorsMonitoringSystem, i: number) =>
                      <div className={`oneItem oneItemInner ${p.isActive ? 'active' : 'default'}`} key={i} onClick={() => { selectMonitoringSystem(i, p.OBJECTID) }}>
                        <span className="tabSpan tabSpanEllipsis" title={Utils.removeHTMLTag(p.monitoring_system)}>{Utils.removeHTMLTag(p.monitoring_system)}</span>
                        <FontAwesomeIcon className="tabIcon deleteIcon oneitemBtn" icon={faTrash} onClick={(e) => { deleteMonitoringSystem(e, i, p.OBJECTID) }} />
                      </div>
                    )}
                  </div>
                </div>
              }

              {props.state.privateSectorSuccessFactorsTab?.isGlobalMode && getSelectedMonitoringSystem() &&
                <div className="itemsRight itemsRightInner">
                  <div className="row">
                    <span className="titleSpan mediumText">18a. {t('newReport.successFactors.monitoringtools')}</span>
                    {/* <p>
                      <input className="mediumText big unsetMaxWidth" type="text" required={isRequiredMonitoring('monitoring_system')}
                      maxLength={9999}
                      placeholder={t('newReport.successFactors.monitoringtoolsPlaceholder')} value={getSelectedMonitoringSystem()?.monitoring_system || ''} onChange={(e) => { updateSelectedMonitoringSystem('monitoring_system', e.target.value) }} /> 
                      </p> */}
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateMonSys}
                        onEditorStateChange={handleEditorMonSys}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                  </div>

                  <div className={`row multiselectRow ${isRequiredMonitoring('track_list') ? "required" : ""}`}>
                    <span className="titleSpan mediumText">18b. {t('newReport.successFactors.metricstools')}</span>

                    <div className="col-6">
                      <Select classNamePrefix="multiselect" placeholder={t('newReport.successFactors.metricstoolsPlaceholder')}
                        closeMenuOnSelect={true} isMulti
                        options={localState.monitoringTrackedElemFeatures.map((i: IRefMonitoringTrackedElemFeature) => { return { label: i.value, value: i.key_ } })}
                        onChange={handleSystemTrackChange}
                        value={
                          localState.monitoringTrackedElemFeatures.map((i: IRefMonitoringTrackedElemFeature) => { return { label: i.value, value: i.key_ } })
                            .filter(option => (getSelectedMonitoringSystem()?.track_list || '').split(',').indexOf(option.value || '---') !== -1)
                        } />
                    </div>

                    <div className="col-6">
                      <input className="mediumText small right" type="text" required={isRequiredMonitoring('other')} placeholder={t('newReport.ifOtherSelected')}
                        disabled={!localState.otherSystemTrackEnabled} value={getSelectedMonitoringSystem()?.other} onChange={(e) => { updateSelectedMonitoringSystem('other', e.target.value) }} />
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">18c. {t('newReport.successFactors.monitoringContributed')}</span>
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateMonContr}
                        onEditorStateChange={handleEditorMonContr}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <p>
                        <textarea className="commonText big"
                        maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'information')?.length || 9999}
                        rows={5} placeholder={t('newReport.successFactors.monitoringtoolsPlaceholder')} value={getSelectedMonitoringSystem()?.information || ''} onChange={(e) => { updateSelectedMonitoringSystem('information', e.target.value) }} /> </p> */}
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">18d. {t('newReport.successFactors.monitoringRelevantCitations')}</span>
                    <div className={`alEditorDiv ${isRequiredMonitoring('links') ? "requiredField" : ""}`} >
                      <Editor
                        editorState={editorStateMonCit}
                        onEditorStateChange={handleEditorMonCit}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <textarea className="commonText big" required={isRequiredMonitoring('links')}
                        maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'links')?.length || 9999}
                        rows={5} placeholder={t('newReport.successFactors.monitoringRelevantCitationsPlaceholder')} value={getSelectedMonitoringSystem()?.links || ''} onChange={(e) => { updateSelectedMonitoringSystem('links', e.target.value) }} /> */}
                  </div>
                </div>
              }

              {!props.state.privateSectorSuccessFactorsTab?.isGlobalMode && getSelectedMonitoringSystem() &&
                <div className="itemsRight itemsRightInner">
                  <div className="row">
                    <span className="titleSpan mediumText">18a. {t('newReport.successFactors.monitoringtools')}</span>
                    {/* <p><input className="mediumText big unsetMaxWidth" type="text" required={isRequiredMonitoring('monitoring_system')}
                      maxLength={9999}
                      placeholder={t('newReport.successFactors.monitoringtoolsPlaceholder')} value={getSelectedMonitoringSystem()?.monitoring_system || ''} onChange={(e) => { updateSelectedMonitoringSystem('monitoring_system', e.target.value) }} /> 
                      </p> */}
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateMonSys}
                        onEditorStateChange={handleEditorMonSys}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                  </div>

                  <div className={`row multiselectRow ${isRequiredMonitoring('track_list') ? "required" : ""}`}>
                    <span className="titleSpan mediumText">18b. {t('newReport.successFactors.metricstools')}</span>

                    <div className="col-6">
                      <Select classNamePrefix="multiselect" placeholder={t('newReport.successFactors.metricstoolsPlaceholder')}
                        closeMenuOnSelect={true} isMulti
                        options={localState.monitoringTrackedElemFeatures.map((i: IRefMonitoringTrackedElemFeature) => { return { label: i.value, value: i.key_ } })}
                        onChange={handleSystemTrackChange}
                        value={
                          localState.monitoringTrackedElemFeatures.map((i: IRefMonitoringTrackedElemFeature) => { return { label: i.value, value: i.key_ } })
                            .filter(option => (getSelectedMonitoringSystem()?.track_list || '').split(',').indexOf(option.value || '---') !== -1)
                        } />
                    </div>

                    <div className="col-6">
                      <input className="mediumText small right" type="text" required={isRequiredMonitoring('other')} placeholder={t('newReport.ifOtherSelected')}
                        disabled={!localState.otherSystemTrackEnabled} value={getSelectedMonitoringSystem()?.other} onChange={(e) => { updateSelectedMonitoringSystem('other', e.target.value) }} />
                    </div>
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">18c. {t('newReport.successFactors.monitoringContributed')}</span>
                    <div className="alEditorDiv">
                      <Editor
                        editorState={editorStateMonContr}
                        onEditorStateChange={handleEditorMonContr}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <p>
                  <textarea className="commonText big"
                  maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'information')?.length || 9999}
                  rows={5} placeholder={t('newReport.successFactors.monitoringtoolsPlaceholder')} value={getSelectedMonitoringSystem()?.information || ''} onChange={(e) => { updateSelectedMonitoringSystem('information', e.target.value) }} /> </p> */}
                  </div>

                  <div className="row">
                    <span className="titleSpan mediumText">18d. {t('newReport.successFactors.monitoringRelevantCitations')}</span>
                    <div className={`alEditorDiv ${isRequiredMonitoring('links') ? "requiredField" : ""}`} >
                      <Editor
                        editorState={editorStateMonCit}
                        onEditorStateChange={handleEditorMonCit}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          options: ['link'],
                          link: { inDropdown: true },
                        }}
                      />
                    </div>
                    {/* <textarea className="commonText big" required={isRequiredMonitoring('links')}
                  maxLength={Utils.getFieldInfos(localState.reportTechnicalPlanningLayerIndex, 'links')?.length || 9999}
                  rows={5} placeholder={t('newReport.successFactors.monitoringRelevantCitationsPlaceholder')} value={getSelectedMonitoringSystem()?.links || ''} onChange={(e) => { updateSelectedMonitoringSystem('links', e.target.value) }} /> */}
                  </div>
                </div>
              }



            </div>
          </div>
        </div>
      </div>
      <Modal show={showRevertToGlobalDialog} onHide={handleRevertToGlobalDialogClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('newReport.resultsAndBenefits.confirmRevertToGlobalTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('newReport.successFactors.confirmSuccessFactorRevertToGlobalContent')}</Modal.Body>
        <Modal.Footer>
          <button className="dialogBtn secondary" onClick={handleRevertToGlobalDialogClose}>
            {t('newReport.resultsAndBenefits.cancelRevertToGlobal')}
          </button>
          <button className="dialogBtn primary" onClick={handleRevertToGlobalConfirmRevert}>
            {t('newReport.resultsAndBenefits.confirmRevertToGlobal')}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPolicyDialog} onHide={handlePolicyDialogClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('newReport.successFactors.confirmDeletePolicyTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('newReport.successFactors.confirmDeletePolicyContent')}</Modal.Body>
        <Modal.Footer>
          <button className="dialogBtn secondary" onClick={handlePolicyDialogClose}>
            {t('newReport.successFactors.cofirmCancel')}
          </button>
          <button className="dialogBtn primary" onClick={handlePolicyConfirmDelete}>
            {t('newReport.successFactors.confirmDelete')}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPlanningMethodologyDialog} onHide={handlePlanningMethodologyDialogClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('newReport.successFactors.confirmDeletePlanningMethodTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('newReport.successFactors.confirmDeletePlanningMethodContent')}</Modal.Body>
        <Modal.Footer>
          <button className="dialogBtn secondary" onClick={handlePlanningMethodologyDialogClose}>
            {t('newReport.successFactors.cofirmCancel')}
          </button>
          <button className="dialogBtn primary" onClick={handlePlanningMethodologyConfirmDelete}>
            {t('newReport.successFactors.confirmDelete')}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showMonitoringSystemDialog} onHide={handleMonitoringSystemDialogClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('newReport.successFactors.confirmDeleteMonitoringSystemTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('newReport.successFactors.confirmDeleteMonitoringSystemContent')}</Modal.Body>
        <Modal.Footer>
          <button className="dialogBtn secondary" onClick={handleMonitoringSystemDialogClose}>
            {t('newReport.successFactors.cofirmCancel')}
          </button>
          <button className="dialogBtn primary" onClick={handleMonitoringSystemConfirmDelete}>
            {t('newReport.successFactors.confirmDelete')}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SectorSuccessFactors;

